// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей): граф схемы v2 — чистая логика атрибута AttrSchemeGraph
// на SVG-движке графа переходов согласования (utils/transitionsGraph.js: точка выхода из прямоугольника, стрелка, расстановка узлов, масштаб указателя, короткая подпись).
// Слово Игоря 25.10: «расположи граф по аналогии с переходами согласования (AttrTransitionsGraph), взаимное выделение при переходе по строкам грида и при клике
// по графу, виды связей пунктирные нескольких видов». Контракт v2 — ie-dm7 plan_map/SPEC.md «Контракт AttrSchemeGraph v2».
// Узлы и группы — те же, что v1 (schemeGraph.collectNodes: лист doc.nodes = узел, строка с attrs = группа-рамка). Связи — КАЖДАЯ строка doc.edges своим ребром
// (key r:<индекс строки>; несколько строк одной пары — веером, строка с одинаковыми концами — петлёй, как у переходов). Вид связи — запись edge_kinds по полю
// edge_kind_binding (стиль линии: solid | dashed | dotted, цвет, толщина, стрелка); вне списка / пусто — запись default: true, нет её (или edge_kinds не задан) —
// серая сплошная. Раскладка — dagre LR (как v1), узлы — прямоугольники с полным названием (перенос по словам, без обрезки), над узлом — полоса под заголовки его
// групп (заголовок рамки не ложится на узел). Сохранённая расстановка {ключ узла: {x, y}} (layout_binding; без него — в памяти компонента) ставит узлы точно,
// рамки и рёбра считаются заново. Выключатель fe.ux.schemeGraphV2 (дефолт ВКЛ; выкл — v1 на AttrGraph / sigma). Тест: tests/unit/schemeGraphV2.test.mjs
import dagre from 'dagre'
import { getPath, keyOf, localized, sgConfig, collectNodes, SG_COLORS, SG_NODE_COLOR } from '@/utils/schemeGraph'
import { rectEdgePoint, arrow, normalizeLayout, layoutKey, shortLabel } from '@/utils/transitionsGraph'   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): shortLabel — текст подписи ребра для места подписи

export const SG2_FLAG = 'fe.ux.schemeGraphV2'
export function schemeGraphV2On(setting) {
    try { return (typeof setting === 'function' ? setting(SG2_FLAG, true) : true) !== false } catch (e) { return true }
}
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): быстрая тяга узла (правило §8 — свой выключатель, дефолт ВКЛ, без пересборки): на pointermove перекладываются только рёбра
// перетаскиваемого узла и рёбра, задевшие его старое / новое место, кадр — не чаще requestAnimationFrame; на pointerup — полный пересчёт. Выкл — полный пересчёт на каждое движение
export const SG2_DRAG_FLAG = 'fe.ux.schemeGraphDragFast'
export function sg2DragFastOn(setting) {
    try { return (typeof setting === 'function' ? setting(SG2_DRAG_FLAG, true) : true) !== false } catch (e) { return true }
}
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): островок кнопок как у AttrGraph (справа внизу: «Типове розташування», растянуть / сжать по высоте
// и ширине, вписать, легенда), легенда видов связей по умолчанию скрыта, граф — в реестре attrs_vueObj (кнопки attrFrontMethod доходят до компонента). Свой выключатель (§8, дефолт ВКЛ,
// без пересборки); выкл — как было: легенда видна, «Default layout» в строке над графом, масштаб 1, без реестра
export const SG2_TOOLBAR_FLAG = 'fe.ux.schemeGraphToolbar'
export function sg2ToolbarOn(setting) {
    try { return (typeof setting === 'function' ? setting(SG2_TOOLBAR_FLAG, true) : true) !== false } catch (e) { return true }
}

// геометрия (единицы svg = px при масштабе 1): узел — прямоугольник nodeMinW…nodeMaxW, строка lineH; полоса заголовка группы titleH над узлом на каждый уровень вложенности
export const SG2 = Object.freeze({ nodeMinW: 96, nodeMaxW: 240, padX: 10, lineH: 15, nodeH: 30, titleH: 18, framePad: 8, nodesep: 24, ranksep: 90, edgesep: 20,
    margin: 14, charW: 6.6, titleCharW: 7, fan: 22, loopR: 30, loopStep: 18,
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — правки пробы): stripW — поле текста от края узла не уже цветной полосы (x+1…x+4) с зазором; обход узлов: hitPad — зазор проверки, maxBend — предел изгиба дуги,
    // backBend — начальный изгиб обратного ребра (не глубокой дугой под все узлы), cell / routePad / cornerR — сетка ломаной в обход, зазор до узла, скругление углов
    stripW: 10, hitPad: 3, maxBend: 150, backBend: 56, bendStep: 28, cell: 10, routePad: 7, cornerR: 10,
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): textK / textPad — запас ширины текста узла (проба dev02: svg-текст шире замера canvas на ~5 %, зазор полоска→текст 0,8 px);
    // labelH / labelPad — рамка подписи ребра для выбора места вдоль линии, свободного от узлов
    textK: 1.06, textPad: 2, labelH: 16, labelPad: 4,
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — место под подписи): место под подписи рёбер в авторасстановке (dagre: подпись — узел-метка между слоями, labelpos 'c'):
    // labelMaxW — предел ширины, под которую раскладка раздвигает слои (длиннее — подпись обрезается по месту «…»), labelMinChars — короче не обрезается
    labelMaxW: 200, labelMinChars: 6,
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — колонки групп): раскладка lanes (layout_mode 'lanes') — колонка на группу верхнего уровня doc.nodes; laneGap — зазор между рамками колонок
    // (не меньше; подписи рёбер между колонками раздвигают их сильнее), laneRowGap — ровный шаг между узлами колонки (зазор между прямоугольниками)
    laneGap: 120, laneRowGap: 40 })
export const SG2_EDGE_COLOR = '#8a94a6'
export const SG2_NEG_COLOR = '#c0392b'   // sign −1 — красный оттенок
export const SG2_DEFAULT_KIND = Object.freeze({ id: '', title: '', line: 'solid', color: SG2_EDGE_COLOR, width: 1.6, arrow: true, default: true, builtin: true })

const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
const str = (v) => (v == null ? '' : String(v))
const r1 = (v) => Math.round(v * 10) / 10
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): множитель оси (graph_scale_x / _y): не число / ≤ 0 — 1
const scaleNum = (v) => { const n = Number(v); return Number.isFinite(n) && n > 0 ? n : 1 }
const scaleOf = (s) => ({ fx: scaleNum(s && s.fx), fy: scaleNum(s && s.fy) })
const COLOR_RE = /^(#[0-9a-f]{3,8}|rgba?\([0-9.,\s%]+\)|hsla?\([0-9.,\s%deg]+\)|[a-z]{3,20})$/i

// ---------- IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета графа схемы как на слайде): цвет группы и узла — строка doc.nodes (nodes_color_binding), заливка узла — nodes_fill_binding ----------
// Группа — рамка залита тоном цвета (alpha SG2_TONE_ALPHA), бордюр и подпись цветом; узел — рамка и подпись цветом, фон светлый; fill — фон узла = цвет, текст SG2_FILL_TEXT,
// если его контраст с цветом < 4,5 (WCAG AA) — белый, затем чёрный (первый с ≥ 4,5; у белого или чёрного он не ниже 4,58 всегда). Подпись цветом на своём фоне с контрастом < 4,5 —
// тот же тон, затемнённый до 4,5. Тёмная тема приложения — filter: invert(1) на корне (App.vue .dark-theme): цвета видны обращёнными (как цвета видов связей и образец в гриде),
// текст и подписи для неё — отдельные переменные (--…d), подобранные к обращённому фону. Цвет — '#RGB' / '#RRGGBB' / 'RRGGBB' / rgb(); иное — своего цвета нет: как было.
// Свой выключатель (§8, дефолт ВКЛ, без пересборки); выкл — прежние цвета (полоска цветом узла, серые рамки групп)
export const SG2_COLORS_FLAG = 'fe.ux.schemeGraphColors'
export function sg2ColorsOn(setting) {
    try { return (typeof setting === 'function' ? setting(SG2_COLORS_FLAG, true) : true) !== false } catch (e) { return true }
}
export const SG2_TONE_ALPHA = 0.12
export const SG2_FILL_TEXT = '#F6F5F0'
export const SG2_MIN_CONTRAST = 4.5
const SG2_BG = '#FFFFFF'   // фон узла и холста светлой темы (surface-card); в тёмной — его обращение
const hex2 = (n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, '0').toUpperCase()
export function sg2Rgb(c) {
    if (isObj(c) && Number.isFinite(c.r) && Number.isFinite(c.g) && Number.isFinite(c.b)) return c
    const s = str(c).trim()
    let h = s[0] === '#' ? s.slice(1) : /^[0-9a-f]{6}$/i.test(s) ? s : ''
    if (h && /^[0-9a-f]+$/i.test(h) && [3, 6, 8].includes(h.length)) {
        if (h.length === 3) h = h.replace(/./g, (x) => x + x)
        return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) }
    }
    const m = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*[0-9.]+%?\s*)?\)$/i.exec(s)
    if (m && [m[1], m[2], m[3]].every((v) => Number(v) <= 255)) return { r: Number(m[1]), g: Number(m[2]), b: Number(m[3]) }
    return null
}
// '#RRGGBB'; не цвет — ''
export function sg2Hex(c) { const v = sg2Rgb(c); return v ? '#' + hex2(v.r) + hex2(v.g) + hex2(v.b) : '' }
// относительная яркость и контраст (WCAG 2)
export function sg2Lum(c) {
    const v = sg2Rgb(c)
    if (!v) return 0
    const lin = (x) => { x /= 255; return x <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4) }
    return 0.2126 * lin(v.r) + 0.7152 * lin(v.g) + 0.0722 * lin(v.b)
}
export function sg2Contrast(a, b) { const x = sg2Lum(a), y = sg2Lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05) }
// a поверх b с долей t (1 — сам a): видимый цвет полупрозрачной заливки на фоне
export function sg2Mix(a, b, t) {
    const p = sg2Rgb(a), q = sg2Rgb(b)
    return p && q ? sg2Hex({ r: p.r * t + q.r * (1 - t), g: p.g * t + q.g * (1 - t), b: p.b * t + q.b * (1 - t) }) : ''
}
// обращение (тёмная тема — invert(1))
export function sg2Inv(c) { const v = sg2Rgb(c); return v ? sg2Hex({ r: 255 - v.r, g: 255 - v.g, b: 255 - v.b }) : '' }
export function sg2Tone(c, alpha = SG2_TONE_ALPHA) { const v = sg2Rgb(c); return v ? `rgba(${v.r}, ${v.g}, ${v.b}, ${alpha})` : '' }
// текст цветом c на фоне bg с контрастом ≥ min: сам c, иначе ближайший шаг от него к чёрному (светлый фон) / к белому (тёмный фон)
export function sg2Readable(c, bg = SG2_BG, min = SG2_MIN_CONTRAST) {
    const h = sg2Hex(c)
    if (!h) return ''
    if (sg2Contrast(h, bg) >= min) return h
    const to = sg2Lum(bg) > 0.18 ? '#000000' : '#FFFFFF'
    for (let i = 1; i < 25; i++) { const x = sg2Mix(to, h, i / 25); if (sg2Contrast(x, bg) >= min) return x }
    return to
}
// текст на заливке c: SG2_FILL_TEXT, белый, чёрный — первый с контрастом ≥ min, иначе самый контрастный из них
export function sg2FillText(c, min = SG2_MIN_CONTRAST) {
    const h = sg2Hex(c)
    if (!h) return ''
    const list = [SG2_FILL_TEXT, '#FFFFFF', '#000000']
    return list.find((x) => sg2Contrast(x, h) >= min) || list.reduce((a, b) => (sg2Contrast(b, h) > sg2Contrast(a, h) ? b : a))
}
// строки doc.nodes по пути collectNodes (верхний уровень — индекс в списке, вложенные — среди объектов children_path): '0.2' → строка
function sg2RowsByPath(rows, cfg) {
    const map = new Map()
    const walk = (list, path) => list.forEach((row, i) => {
        if (!isObj(row)) return
        const p = path.concat(i)
        map.set(p.join('.'), row)
        const k = cfg.children_path ? getPath(row, cfg.children_path) : undefined
        if (Array.isArray(k)) walk(k.filter(isObj), p)
    })
    walk(Array.isArray(rows) ? rows : [], [])
    return map
}
// узел (лист sg2Graph: own, fill) → { cls, style } — CSS-переменные правил AttrSchemeGraphV2.vue: --sg2-nc рамка (и фон при fill), --sg2-nl / --sg2-nld подпись
// (светлая / тёмная тема), --sg2-nt / --sg2-ntd текст на заливке; своего цвета нет или выключатель выкл — null (как было)
export function sg2NodePaint(n, on) {
    const c = on && n ? sg2Hex(n.own) : ''
    if (!c) return null
    if (n.fill) return { cls: 'sg2-col sg2-fill', style: { '--sg2-nc': c, '--sg2-nt': sg2FillText(c), '--sg2-ntd': sg2Inv(sg2FillText(sg2Inv(c))) } }
    return { cls: 'sg2-col', style: { '--sg2-nc': c, '--sg2-nl': sg2Readable(c), '--sg2-nld': sg2Inv(sg2Readable(sg2Inv(c), sg2Inv(SG2_BG))) } }
}
// группа (sg2Graph: color) → style: --sg2-gt тон (заливка рамки), --sg2-gc бордюр, --sg2-gl / --sg2-gld подпись на тоне (светлая / тёмная тема); нет цвета / выкл — null
export function sg2FramePaint(gr, on) {
    const c = on && gr ? sg2Hex(gr.color) : ''
    if (!c) return null
    const bg = sg2Mix(c, SG2_BG, SG2_TONE_ALPHA)
    return { '--sg2-gt': sg2Tone(c), '--sg2-gc': c, '--sg2-gl': sg2Readable(c, bg), '--sg2-gld': sg2Inv(sg2Readable(sg2Inv(c), sg2Inv(bg))) }
}
// граф → { nodes: {id: {cls, style}}, frames: {gid: style} } — только узлы и группы со своим цветом; выкл — пусто
export function sg2Paint(g, on) {
    const out = { nodes: {}, frames: {} }
    if (!g || !on) return out
    for (const l of g.leaves || []) { const p = sg2NodePaint(l, true); if (p) out.nodes[l.id] = p }
    for (const gr of g.groups || []) { const p = sg2FramePaint(gr, true); if (p) out.frames[gr.gid] = p }
    return out
}

// ---------- конфигурация v2: v1 (sgConfig) + новые параметры; без них — прежнее поведение (стиль по умолчанию, без легенды, без грида, расстановка в памяти) ----------
const DEF2 = { edge_kind_binding: 'kind', edge_title_binding: '', edge_sign_binding: 'sign', edges_use_binding: 'use', layout_binding: '', edges_grid_name: '', nodes_grid_name: '',
    layout_mode: '' }   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — колонки групп): 'lanes' — колонки групп (бэк ставит для DATA-SCHEME); пусто / 'layers' / иное — dagre LR, как было
DEF2.nodes_fill_binding = ''   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета графа схемы как на слайде): поле заливки узла (bool, бэк — 'fill'); пусто — без заливки, как было
DEF2.edges_color_binding = ''   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы — цвет связей, виджет строки по клику): поле цвета строки doc.edges (бэк — 'color'); пусто — цвет вида, как было
export function sg2Config(attr) {
    const a = isObj(attr) ? attr : {}
    const p = isObj(a.params) ? a.params : {}
    const pick = (k) => (typeof a[k] === 'string' ? a[k] : typeof p[k] === 'string' ? p[k] : undefined)
    const { cfg, errors } = sgConfig(attr)
    for (const k of Object.keys(DEF2)) { const v = pick(k); cfg[k] = v === undefined ? DEF2[k] : v.trim() }
    if (!cfg.edge_title_binding && cfg.edges_title_binding) cfg.edge_title_binding = cfg.edges_title_binding   // имя v1 — запасное
    cfg.layout_mode = cfg.layout_mode.toLowerCase() === 'lanes' ? 'lanes' : 'layers'   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — колонки групп)
    const kinds = Array.isArray(a.edge_kinds) ? a.edge_kinds : Array.isArray(p.edge_kinds) ? p.edge_kinds : []
    cfg.edge_kinds = kinds.filter(isObj)
    return { cfg, errors }
}

// ---------- виды связей ----------
// штрих по виду линии и толщине: dashed — «— —», dotted — точки (круглый конец нулевого штриха)
export function sg2Dash(line, width) {
    const w = Number(width) || 1.6
    if (line === 'dashed') return { dash: `${r1(w * 3 + 3)} ${r1(w * 2 + 2)}`, cap: 'butt' }
    if (line === 'dotted') return { dash: `0.1 ${r1(w * 2.2 + 1.6)}`, cap: 'round' }
    return { dash: '', cap: 'butt' }
}
function kindStyle(k, lang) {
    const line = ['solid', 'dashed', 'dotted'].includes(str(k.line).trim()) ? str(k.line).trim() : 'solid'
    const c = str(k.color).trim()
    const wn = Number(k.width)
    const width = Number.isFinite(wn) && wn > 0 ? Math.min(4, Math.max(1, wn)) : 1.6
    const id = keyOf(k.id !== undefined ? k.id : k.value)
    return { id, title: localized(k, 'title', lang) || id, line, color: COLOR_RE.test(c) ? c : SG2_EDGE_COLOR, ownColor: COLOR_RE.test(c), width, arrow: k.arrow !== false, default: k.default === true, ...sg2Dash(line, width) }   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — правки пробы): ownColor — цвет задан видом
}
// edge_kinds → { list (порядок легенды), byId, def (первая default: true; нет — встроенная серая сплошная) }
export function sg2Kinds(list, lang) {
    const out = [], byId = new Map()
    for (const k of Array.isArray(list) ? list : []) {
        if (!isObj(k)) continue
        const s = kindStyle(k, lang)
        if (!s.id || byId.has(s.id)) continue
        out.push(s); byId.set(s.id, s)
    }
    const def = out.find((k) => k.default) || { ...SG2_DEFAULT_KIND, ...sg2Dash('solid', SG2_DEFAULT_KIND.width) }
    return { list: out, byId, def }
}

// ---------- связи: строка = ребро ----------
// ключ строки для сверки с гридом без ссылки на тот же объект: концы + вид
export function sg2RowKey(row, cfg) {
    if (!isObj(row)) return ''
    return [keyOf(getPath(row, cfg.edges_source_binding)), keyOf(getPath(row, cfg.edges_target_binding)), cfg.edge_kind_binding ? keyOf(getPath(row, cfg.edge_kind_binding)) : ''].join('\u0001')
}
// edges: [{key, index, from, to, kind, kindTitle, color, width, dash, cap, arrow, sign, use, title, loop}]; dangling: [{index, source, target, reason}]
export function sg2Edges(rows, nodes, cfg, kinds, lang) {
    const edges = [], dangling = []
    const K = kinds || sg2Kinds([], lang)
    ;(Array.isArray(rows) ? rows : []).forEach((row, index) => {
        if (!isObj(row)) return
        const s = keyOf(getPath(row, cfg.edges_source_binding)), t_ = keyOf(getPath(row, cfg.edges_target_binding))
        const why = (k) => (!k ? 'empty' : nodes.byKey.has(k) ? '' : nodes.groupKeys.has(k) ? 'group' : 'missing')
        const ws = why(s), wt = why(t_)
        if (ws || wt) { dangling.push({ index, source: s, target: t_, reason: ws || wt }); return }
        const kid = cfg.edge_kind_binding ? keyOf(getPath(row, cfg.edge_kind_binding)) : ''
        const k = (kid && K.byId.get(kid)) || K.def
        const sign = cfg.edge_sign_binding && Number(getPath(row, cfg.edge_sign_binding)) === -1 ? -1 : 1
        const use = cfg.edges_use_binding ? getPath(row, cfg.edges_use_binding) !== false : true
        const from = sg2NodeId(nodes.byKey.get(s)), to = sg2NodeId(nodes.byKey.get(t_))
        // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — правки пробы): цвет линии — всегда цвет вида (как в легенде); sign −1 — знаком «−» у линии и в подписи; красный — только виду без своего цвета
        edges.push({ key: `r:${index}`, index, from, to, kind: k.id, kindTitle: k.builtin ? '' : k.title, color: sign < 0 && !k.ownColor ? SG2_NEG_COLOR : k.color, width: k.width, dash: k.dash, cap: k.cap,
            arrow: k.arrow, sign, use, title: cfg.edge_title_binding ? localized(row, cfg.edge_title_binding, lang) : '', loop: from === to })
    })
    return { edges, dangling }
}
// id узла в модели и в расстановке: ключ строки (name); дубль / без ключа — служебный gkey (n:#путь)
export const sg2NodeId = (leaf) => (leaf ? (leaf.key && leaf.gkey === `n:${leaf.key}` ? leaf.key : leaf.gkey) : '')

// ---------- узлы: перенос названия по словам (без обрезки) ----------
export function sg2Wrap(text, maxW, measure) {
    const m = typeof measure === 'function' ? measure : (s) => str(s).length * SG2.charW
    const words = str(text).trim().split(/\s+/).filter(Boolean)
    if (!words.length) return ['?']
    const lines = []
    let cur = ''
    const pushLong = (w) => {   // слово шире строки — по символам
        let part = ''
        for (const ch of w) { if (part && m(part + ch) > maxW) { lines.push(part); part = ch } else part += ch }
        return part
    }
    for (const w of words) {
        const cand = cur ? cur + ' ' + w : w
        if (m(cand) <= maxW) { cur = cand; continue }
        if (cur) lines.push(cur)
        cur = m(w) > maxW ? pushLong(w) : w
    }
    if (cur) lines.push(cur)
    return lines
}
export function sg2NodeBox(title, measure, o = SG2) {
    const m0 = typeof measure === 'function' ? measure : (s) => str(s).length * o.charW
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): запас к замеру (× textK + textPad) — и в переносе, и в ширине: фактический svg-текст шире замера canvas до ~6 % — зазор полоска→текст не меньше 4 px
    const m = (s) => m0(s) * (o.textK || 1) + (o.textPad || 0)
    const side = Math.max(o.padX, o.stripW || 0)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — правки пробы): текст по центру — поле с каждой стороны не уже цветной полосы с зазором
    const inner = o.nodeMaxW - 2 * side
    const lines = sg2Wrap(title, inner, m)
    const tw = Math.max(...lines.map((l) => m(l)))
    return { lines, w: Math.ceil(Math.min(o.nodeMaxW, Math.max(o.nodeMinW, tw + 2 * side + 4))), h: Math.max(o.nodeH, lines.length * o.lineH + 12) }
}

// ---------- граф: узлы, группы, связи ----------
// rows — строки табличных частей; → { nodes (collectNodes v1), leaves: [{id, key, gkey, title, lines, w, h, use, color, doc, groups, top}], groups (живые: с узлами), kinds, edges, dangling }
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — место под подписи): measureLabel — ширина текста подписи ребра (шрифт подписи); labelW {ключ ребра: ширина} — место под подписи в авторасстановке
export function sg2Graph(nodesRows, edgesRows, cfg, lang, measure, measureLabel) {
    const nodes = collectNodes(nodesRows, cfg, lang)
    const kinds = sg2Kinds(cfg.edge_kinds, lang)
    const ed = sg2Edges(edgesRows, nodes, cfg, kinds, lang)
    const leaves = nodes.leaves.map((l) => {
        const b = sg2NodeBox(l.label, measure)
        return { id: sg2NodeId(l), key: l.key, gkey: l.gkey, title: l.label, lines: b.lines, w: b.w, h: b.h, use: l.use, color: l.color || SG_COLORS[l.top % SG_COLORS.length] || SG_NODE_COLOR,
            doc: l.doc, groups: l.groups.slice(), top: l.top }
    })
    const groups = nodes.groups.filter((g) => g.leaves.length).map((g) => ({ gid: g.gid, key: g.key, title: g.title, depth: g.depth, parent: g.parent,
        leaves: g.leaves.map((gk) => sg2NodeId(nodes.leaves.find((l) => l.gkey === gk))) }))
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета графа схемы как на слайде): свой цвет узла own ('#RRGGBB' или '') и заливка fill — из его строки, цвет группы color — из строки-группы;
    // color листа (полоска, как было) не меняется; в подпись раскладки цвета не входят — перекраска не двигает узлы
    const rowAt = sg2RowsByPath(nodesRows, cfg)
    const fillOf = (row) => { const v = row && cfg.nodes_fill_binding ? getPath(row, cfg.nodes_fill_binding) : undefined; return v === true || v === 'true' || v === 1 }
    nodes.leaves.forEach((l, i) => { const own = sg2Hex(l.color); leaves[i].own = own; leaves[i].fill = !!own && fillOf(rowAt.get(l.path)) })
    for (const gr of groups) { const row = rowAt.get(gr.gid.slice(2)); gr.color = row && cfg.nodes_color_binding ? sg2Hex(getPath(row, cfg.nodes_color_binding)) : '' }
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы — цвет связей, виджет строки по клику): свой цвет связи own ('#RRGGBB' | '') — из её строки (edges_color_binding); e.color (цвет вида) не меняется
    for (const e of ed.edges) e.own = sg2EdgeOwn(Array.isArray(edgesRows) ? edgesRows[e.index] : null, cfg)
    const labelW = {}   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — место под подписи)
    for (const e of ed.edges) { const lt = e.loop ? '' : sg2EdgeLabel(e); if (lt) labelW[e.key] = r1(typeof measureLabel === 'function' ? measureLabel(lt) : lt.length * SG2.charW) }
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — колонки групп): слово Игоря 25.10 «сделай, чтобы планы визуализировались как на слайде» — режим lanes: колонка на группу верхнего уровня
    // (порядок групп doc.nodes слева направо), узлы колонки — столбиком в порядке строк, одинаковой ширины (по самому длинному названию колонки, перенос — как был, не шире nodeMaxW)
    // и высоты; узлы вне групп — последней колонкой. lanes: [{gid, title, leaves: [id]}]; titleW {заголовок группы: ширина} — ширина рамки колонки в раскладке.
    // Заголовок рамки шире узлов — узлы колонки расширяются до него (не шире nodeMaxW): рамка не свисает вправо от узлов, узлы — по центру полосы, как на слайде
    const mode = cfg && cfg.layout_mode === 'lanes' ? 'lanes' : 'layers'
    let lanes = null
    const titleW = {}
    if (mode === 'lanes') {
        lanes = []
        const byTop = new Map(), free = { gid: '', title: '', leaves: [] }
        for (const gr of groups) if (gr.depth === 0) { const ln = { gid: gr.gid, title: gr.title, leaves: [] }; lanes.push(ln); byTop.set(gr.gid, ln) }
        for (const l of leaves) (byTop.get(l.groups[0]) || free).leaves.push(l.id)
        if (free.leaves.length) lanes.push(free)
        for (const gr of groups) titleW[gr.title] = r1(typeof measureLabel === 'function' ? measureLabel(str(gr.title)) : str(gr.title).length * SG2.titleCharW)
        const mt = (t_) => Math.max(str(t_).length * SG2.titleCharW, titleW[t_] || 0)
        const byId = new Map(leaves.map((l) => [l.id, l]))
        for (const ln of lanes) {
            const ls = ln.leaves.map((id) => byId.get(id)), set = new Set(ln.leaves)
            let w = Math.max(...ls.map((l) => l.w))
            const h = Math.max(...ls.map((l) => l.h))
            for (const gr of groups) if (gr.leaves.some((id) => set.has(id))) w = Math.max(w, Math.min(SG2.nodeMaxW, Math.ceil(mt(gr.title) + 16 - 2 * SG2.framePad)))
            for (const l of ls) { l.w = w; l.h = h }
        }
    }
    return { nodes, leaves, groups, kinds, edges: ed.edges, dangling: ed.dangling, dupKeys: nodes.dupKeys, labelW, mode, lanes, titleW }
}
// подпись авторасстановки: от чего зависят координаты dagre (состав, размеры узлов, вложенность, пары рёбер)
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): scale — множители осей (растянуть / сжать); 1 × 1 — прежняя подпись
export function sg2LayoutSig(g, scale) {
    const lw = g.labelW || {}   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — место под подписи): и ширины подписей (место под них в раскладке)
    const sig = [g.leaves.map((l) => [l.id, l.w, l.h, l.groups.join('/')]), g.groups.map((x) => [x.gid, x.parent]), g.edges.filter((e) => !e.loop).map((e) => e.from + '>' + e.to + (lw[e.key] ? ':' + Math.round(lw[e.key]) : ''))]
    if (g.mode === 'lanes') sig.push(['lanes', g.groups.map((x) => Math.round((g.titleW || {})[x.title] || 0))])   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — колонки групп): режим и ширины заголовков колонок
    const sc = scaleOf(scale)
    if (sc.fx !== 1 || sc.fy !== 1) sig.push(['scale', sc.fx, sc.fy])   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта)
    return JSON.stringify(sig)
}

// ---------- авторасстановка: dagre LR, группы — кластеры; над узлом — полосы заголовков его групп ----------
// → { id: {x, y} } — центр прямоугольника узла (svg, y вниз)
export function sg2AutoLayout(g, opts = {}) {
    if (g && g.mode === 'lanes' && Array.isArray(g.lanes) && g.lanes.length) return sg2LanesLayout(g, opts)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — колонки групп)
    const o = { ...SG2, ...(opts.geom || {}) }
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): opts.scale — растянуть / сжать: LR — слои по x (ranksep и место под подписи между ними × fx),
    // узлы слоя по y (nodesep, edgesep × fy); узлы не масштабируются
    const { fx, fy } = scaleOf(opts.scale)
    if (fx !== 1 || fy !== 1) { o.ranksep *= fx; o.nodesep *= fy; o.edgesep *= fy }
    const run = (compound) => {
        const G = new dagre.graphlib.Graph({ compound, multigraph: false })
        G.setGraph({ rankdir: 'LR', ranker: 'network-simplex', nodesep: o.nodesep, ranksep: o.ranksep, edgesep: o.edgesep, marginx: 0, marginy: 0 })
        G.setDefaultEdgeLabel(() => ({}))
        if (compound) for (const gr of g.groups) G.setNode(gr.gid, { label: gr.title })
        if (compound) for (const gr of g.groups) if (gr.parent && G.hasNode(gr.parent)) G.setParent(gr.gid, gr.parent)
        for (const l of g.leaves) {
            G.setNode(l.id, { width: l.w, height: l.h + l.groups.length * o.titleH })
            const par = l.groups[l.groups.length - 1]
            if (compound && par && G.hasNode(par)) G.setParent(l.id, par)
        }
        // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — место под подписи): проба dev02 — подпись длиннее ребра между соседними узлами цепочки (КАМ → ПМ → БЮМ → МД стоят вплотную), свободного места
        // вдоль линии нет — 13 из 29 выделений с подписью на узле. Теперь у пары с подписью — метка dagre (labelpos 'c': узел-метка между слоями шириной самой длинной
        // подписи пары, не шире labelMaxW, высотой — веер подписей): слои раздвигаются под подпись, рамки групп считаются по новым местам узлов
        const seen = new Map(), lw = g.labelW || {}
        for (const e of g.edges) {
            if (e.loop) continue
            const k = e.from + '\u0001' + e.to
            const s = seen.get(k) || { from: e.from, to: e.to, n: 0, ln: 0, w: 0 }
            s.n++
            if (lw[e.key]) { s.ln++; s.w = Math.max(s.w, Math.min(lw[e.key], o.labelMaxW)) }
            seen.set(k, s)
        }
        for (const s of seen.values()) {
            // слои и так стоят через ranksep — метка добирает только недостающее: подпись + поля + зазоры до узлов (labelPad, hitPad) + запас 12 px на смещение середины линии
            const room = Math.ceil((s.w + 2 * (o.labelPad + o.hitPad) + 12) * fx - o.ranksep)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): × fx
            G.setEdge(s.from, s.to, s.ln && room > 0 ? { weight: s.n, width: room, height: o.labelH + (s.ln - 1) * o.fan, labelpos: 'c' } : { weight: s.n })
        }
        dagre.layout(G)
        const pos = {}
        for (const l of g.leaves) { const n = G.node(l.id); pos[l.id] = { x: r1(n.x), y: r1(n.y + (l.groups.length * o.titleH) / 2) } }
        return pos
    }
    try { return run(g.groups.length > 0) } catch (e) {
        if (typeof opts.warn === 'function') opts.warn('[AttrSchemeGraph v2] compound layout failed, groups are framed around their nodes', e)
        return run(false)
    }
}

// ---------- IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — колонки групп): раскладка lanes — колонки групп, как на слайде ----------
// колонка i — g.lanes[i]; узлы колонки — столбиком сверху вниз в порядке строк, центры на одной вертикали, шаг ровный: зазор laneRowGap (подпись ребра соседних узлов колонки — не меньше
// её высоты с полями); вход в подгруппу / выход из неё — ещё полоса её заголовка и поле рамки (шаг не меньше обычного). Колонки — слева направо: зазор между рамками ≥ laneGap,
// между узлами соседних колонок — не меньше самой длинной подписи рёбер, которые идут через этот промежуток (≤ labelMaxW, + поля и зазоры, как место подписи в layers).
// Рамки колонок — sg2Frames по тем же местам (ширина рамки — не уже заголовка). Рёбра — общей маршрутизацией (дуги, обход узлов, веер, петли, обратное ребро дугой). → { id: {x, y} }
export function sg2LanesLayout(g, opts = {}) {
    const o = { ...SG2, ...(opts.geom || {}) }
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): opts.scale — растянуть / сжать: зазор колонок и место под подписи между ними × fx
    // (рамки колонок — не ближе 12 px), зазор узлов колонки × fy (не меньше полосы заголовков групп / 14 px); узлы не масштабируются
    const { fx, fy } = scaleOf(opts.scale)
    const byId = new Map(g.leaves.map((l) => [l.id, l]))
    const tw = g.titleW || {}, lw = g.labelW || {}
    const mt = (s) => Math.max(str(s).length * o.titleCharW, tw[s] || 0)   // не уже, чем рамку считает sg2Frames без замера шрифта
    const lanes = g.lanes.map((ln) => ln.leaves.filter((id) => byId.has(id))).filter((ids) => ids.length)
    const laneOf = new Map(), rowOf = new Map()
    lanes.forEach((ids, i) => ids.forEach((id, j) => { laneOf.set(id, i); rowOf.set(id, j) }))
    // место под подписи: по вертикали — у соседних узлов колонки, по горизонтали — в каждом промежутке между колонками, через который идёт ребро
    const rowNeed = lanes.map(() => 0), gapNeed = lanes.map(() => 0)   // gapNeed[i] — промежуток между колонками i − 1 и i
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): vw[i] — самая широкая подпись ребра соседних узлов колонки i: она шире колонки и выступает в промежутки по бокам (проба dev02 r4: подпись
    // вертикального ребра первой колонки ложилась на подписи рёбер через промежуток) — промежуток с подписями раздвигается и на эти выступы
    const vw = lanes.map(() => 0)
    const pairs = new Map()
    for (const e of g.edges) {
        if (e.loop || !lw[e.key]) continue
        const k = [e.from, e.to].sort().join('\u0001')
        const s = pairs.get(k) || { a: e.from, b: e.to, n: 0, w: 0 }
        s.n++; s.w = Math.max(s.w, Math.min(lw[e.key], o.labelMaxW)); pairs.set(k, s)
    }
    for (const s of pairs.values()) {
        const la = laneOf.get(s.a), lb = laneOf.get(s.b)
        if (la === undefined || lb === undefined) continue
        if (la === lb) {
            if (Math.abs(rowOf.get(s.a) - rowOf.get(s.b)) === 1) { rowNeed[la] = Math.max(rowNeed[la], o.labelH + 2 * (o.labelPad + o.hitPad) + 6); vw[la] = Math.max(vw[la], s.w) }
            continue
        }
        const room = Math.ceil(s.w + 2 * (o.labelPad + o.hitPad) + 12)
        for (let i = Math.min(la, lb) + 1; i <= Math.max(la, lb); i++) gapNeed[i] = Math.max(gapNeed[i], room)
    }
    const pos = {}
    // по вертикали: верх рамки колонки — y 0
    lanes.forEach((ids, i) => {
        const gap = Math.max(o.laneRowGap, rowNeed[i])
        let prev = null, y = 0
        for (const id of ids) {
            const l = byId.get(id), L = l.groups.length
            if (!prev) y = o.titleH * L + 2
            else {
                let c = 0
                while (c < L && c < prev.groups.length && l.groups[c] === prev.groups[c]) c++
                y += Math.max(gap * fy, o.framePad * (prev.groups.length - c) + o.titleH * (L - c) + 2 + 12)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): × fy
            }
            pos[id] = { x: 0, y: r1(y + l.h / 2) }
            y += l.h
            prev = l
        }
    })
    // по горизонтали: протяжённость колонки (рамки с заголовками) при центре x 0 — и колонки слева направо
    let cx = 0, pe = null, pw = 0
    lanes.forEach((ids, i) => {
        const set = new Set(ids)
        const sub = { leaves: ids.map((id) => byId.get(id)), groups: g.groups.filter((gr) => gr.leaves.some((id) => set.has(id))) }
        const w = Math.max(...sub.leaves.map((l) => l.w))
        const e = { l: -w / 2, r: w / 2 }
        for (const f of sg2Frames(sub, pos, o, mt)) { e.l = Math.min(e.l, f.x0); e.r = Math.max(e.r, f.x1) }
        const over = (k, wk) => Math.max(0, vw[k] / 2 + o.labelPad + o.hitPad - wk / 2)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): выступ подписи колонки k за её узлы
        // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): × fx (fx 1 — как было)
        const lg = fx === 1 ? o.laneGap : Math.max(12, o.laneGap * fx)
        cx = !pe ? -e.l : Math.max(cx + pe.r + lg - e.l, cx + pw / 2 + (gapNeed[i] ? (gapNeed[i] + over(i - 1, pw) + over(i, w)) * fx : 0) + w / 2)
        for (const id of ids) pos[id].x = r1(cx)
        pe = e; pw = w
    })
    return pos
}

// ---------- рамки групп по фактическим местам узлов ----------
// рамка уровня k вокруг узлов; узел с L группами: поле framePad × (L − k) по бокам и снизу, сверху — полосы заголовков titleH × (L − k); ширина — не уже заголовка
export function sg2Frames(g, pos, o = SG2, measureTitle) {
    const mt = typeof measureTitle === 'function' ? measureTitle : (s) => str(s).length * o.titleCharW
    const leafById = new Map(g.leaves.map((l) => [l.id, l]))
    const frames = []
    for (const gr of [...g.groups].sort((a, b) => a.depth - b.depth)) {
        let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity
        for (const id of gr.leaves) {
            const l = leafById.get(id), p = pos[id]
            if (!l || !p) continue
            const lv = Math.max(1, l.groups.length - gr.depth)
            x0 = Math.min(x0, p.x - l.w / 2 - o.framePad * lv); x1 = Math.max(x1, p.x + l.w / 2 + o.framePad * lv)
            y0 = Math.min(y0, p.y - l.h / 2 - o.titleH * lv - 2); y1 = Math.max(y1, p.y + l.h / 2 + o.framePad * lv)
        }
        if (!(x0 < x1)) continue
        x1 = Math.max(x1, x0 + mt(gr.title) + 16)
        frames.push({ gid: gr.gid, key: gr.key, title: gr.title, depth: gr.depth, x0: r1(x0), y0: r1(y0), x1: r1(x1), y1: r1(y1), tx: r1(x0 + 8), ty: r1(y0 + o.titleH / 2 + 2) })
    }
    return frames
}

// ---------- рёбра: дуги движка переходов (точка выхода из прямоугольника, квадратичная дуга, стрелка), веер пары, петли, обход чужих узлов ----------
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — правки пробы): проба dev02 — рёбра задевали чужие узлы (delta #19, delta-nodes 15 из 53): касание
// проверялось 9 точками кривой (у длинной дуги шаг ~60 px — узел между точками не виден), а обхода, кроме более крутой дуги, не было. Теперь: кривая — ломаной с шагом
// ≤ 4 px, каждый отрезок — точным пересечением с прямоугольником чужого узла (зазор hitPad); дуга не круче maxBend (обратное ребро — начальный изгиб backBend, а не
// 16 % длины: не уходит глубокой дугой под все узлы); ни одна дуга не проходит — ломаная по сетке (A*) в проходах между узлами, углы скруглены; веер пары — штрафом за
// занятые соседними рёбрами клетки; петли — как у переходов.
const qAt = (p0, c, p2, t_) => ({ x: (1 - t_) * (1 - t_) * p0.x + 2 * (1 - t_) * t_ * c.x + t_ * t_ * p2.x, y: (1 - t_) * (1 - t_) * p0.y + 2 * (1 - t_) * t_ * c.y + t_ * t_ * p2.y })
function arc(a, b, bend, sign) {
    const len = Math.hypot(b.x - a.x, b.y - a.y) || 1
    const ux = (b.x - a.x) / len, uy = (b.y - a.y) / len
    const f = a.x <= b.x ? 1 : -1
    const nx = -uy * sign * f, ny = ux * sign * f
    const c = { x: (a.x + b.x) / 2 + nx * bend, y: (a.y + b.y) / 2 + ny * bend }
    const p0 = rectEdgePoint(a.x, a.y, a.w, a.h, c.x, c.y)
    const p2 = rectEdgePoint(b.x, b.y, b.w, b.h, c.x, c.y, 4)
    return { p0, c, p2 }
}
const rectOf = (b, pad) => ({ x0: b.x - b.w / 2 - pad, x1: b.x + b.w / 2 + pad, y0: b.y - b.h / 2 - pad, y1: b.y + b.h / 2 + pad })
// отрезок p→q проходит через внутренность прямоугольника r (Лян — Барски; касание границы / угла — не пересечение)
export function sg2SegHitsRect(p, q, r) {
    let t0 = 0, t1 = 1
    const dx = q.x - p.x, dy = q.y - p.y
    const P = [-dx, dx, -dy, dy], Q = [p.x - r.x0, r.x1 - p.x, p.y - r.y0, r.y1 - p.y]
    for (let i = 0; i < 4; i++) {
        if (P[i] === 0) { if (Q[i] <= 0) return false; continue }
        const v = Q[i] / P[i]
        if (P[i] < 0) { if (v > t1) return false; if (v > t0) t0 = v } else { if (v < t0) return false; if (v < t1) t1 = v }
    }
    return t1 - t0 > 1e-6
}
// число отрезков ломаной pts, задевших прямоугольники rects
export function sg2PolyHits(pts, rects) {
    let n = 0
    for (let i = 1; i < pts.length; i++) {
        const a = pts[i - 1], b = pts[i]
        const x0 = Math.min(a.x, b.x), x1 = Math.max(a.x, b.x), y0 = Math.min(a.y, b.y), y1 = Math.max(a.y, b.y)
        for (const r of rects) if (x1 > r.x0 && x0 < r.x1 && y1 > r.y0 && y0 < r.y1 && sg2SegHitsRect(a, b, r)) n++
    }
    return n
}
// квадратичная дуга → ломаная с шагом ≤ step px
function qPts(p0, c, p2, step = 4) {
    const len = Math.hypot(c.x - p0.x, c.y - p0.y) + Math.hypot(p2.x - c.x, p2.y - c.y)
    const n = Math.max(2, Math.ceil(len / step)), pts = []
    for (let i = 0; i <= n; i++) pts.push(qAt(p0, c, p2, i / n))
    return pts
}
// точка ломаной на доле f длины
function polyAt(pts, f) {
    let L = 0
    for (let i = 1; i < pts.length; i++) L += Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y)
    let need = L * f
    for (let i = 1; i < pts.length; i++) {
        const s = Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y)
        if (s >= need && s > 0) { const k = need / s; return { x: pts[i - 1].x + (pts[i].x - pts[i - 1].x) * k, y: pts[i - 1].y + (pts[i].y - pts[i - 1].y) * k } }
        need -= s
    }
    return pts[pts.length - 1]
}
function polyLen(pts) { let L = 0; for (let i = 1; i < pts.length; i++) L += Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y); return L }
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): подпись ребра (текст — как в svg) и её место: вдоль линии от середины к концам — первое, где рамка подписи не накрывает ни один узел
// (проба dev02: подпись выбранного узла уходила под соседний узел «План ПМ»); свободного нет — место с наименьшим перекрытием
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — место под подписи): у ребра модели — текст на месте (lt: обрезан по месту, если не помещается)
export const sg2EdgeLabel = (e) => (e && typeof e.lt === 'string' ? e.lt : e && (e.title || e.sign < 0) ? (e.sign < 0 ? '− ' : '') + shortLabel(e.title, 28) : '')
const LABEL_AT = [0.5, 0.43, 0.57, 0.36, 0.64, 0.3, 0.7, 0.24, 0.76, 0.18, 0.82, 0.47, 0.53, 0.4, 0.6, 0.33, 0.67, 0.27, 0.73, 0.21, 0.79, 0.15, 0.85, 0.12, 0.88]
export function sg2LabelSpot(pts, lw, rects, o = SG2) { return labelSpotA(pts, lw, rects, o).p }
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — место под подписи): место подписи с площадью перекрытия узлов {p, a}
function labelSpotA(pts, lw, rects, o) {
    const cum = [0]
    for (let i = 1; i < pts.length; i++) cum.push(cum[i - 1] + Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y))
    const L = cum[cum.length - 1]
    const at = (f) => {
        const need = L * f
        let i = 1
        while (i < pts.length - 1 && cum[i] < need) i++
        const s = cum[i] - cum[i - 1], k = s > 0 ? (need - cum[i - 1]) / s : 0
        return { x: pts[i - 1].x + (pts[i].x - pts[i - 1].x) * k, y: pts[i - 1].y + (pts[i].y - pts[i - 1].y) * k }
    }
    const hw = lw / 2 + o.labelPad, hh = o.labelH / 2
    let best = null
    for (const f of LABEL_AT) {
        const p = at(f)
        let a = 0
        for (const r of rects) {
            const ox = Math.min(p.x + hw, r.x1) - Math.max(p.x - hw, r.x0), oy = Math.min(p.y + hh, r.y1) - Math.max(p.y - hh, r.y0)
            if (ox > 0 && oy > 0) a += ox * oy * (r.k || 1)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): r.k — вес (узел — много дороже соседней подписи)
        }
        if (!best || a < best.a) best = { p, a }
        if (a === 0) break
    }
    return best
}
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — место под подписи): подпись и место: полный текст (до 28 символов) там, где он не накрывает узлы; не помещается нигде вдоль линии
// (узлы расставлены вручную вплотную / ребро короче подписи) — обрезка по месту «…» (самый длинный текст, который помещается; не короче labelMinChars),
// полный текст — в Alt-карточке (title ребра). → {p, text}
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): и a — площадь перекрытия на выбранном месте (0 — свободно; раскладка подписей берёт её для выбора)
export function sg2FitLabel(e, pts, rects, measureLabel, o = SG2) {
    const mw = (s) => (typeof measureLabel === 'function' ? measureLabel(s) : s.length * o.charW)
    const full = sg2EdgeLabel(e)
    const b0 = labelSpotA(pts, mw(full), rects, o)
    if (b0.a === 0 || !e.title) return { p: b0.p, text: full, a: b0.a }
    const pre = e.sign < 0 ? '− ' : '', raw = str(e.title).trim()
    const cut = (n) => pre + shortLabel(raw, n)
    let lo = Math.min(o.labelMinChars, raw.length), hi = Math.min(raw.length, 28) - 1, best = null
    while (lo <= hi) {   // самый длинный текст без перекрытия (бинарный поиск по числу символов)
        const n = (lo + hi) >> 1, t_ = cut(n), b = labelSpotA(pts, mw(t_), rects, o)
        if (b.a === 0) { best = { p: b.p, text: t_, a: 0 }; lo = n + 1 } else hi = n - 1
    }
    if (best) return best
    const t_ = cut(Math.min(o.labelMinChars, raw.length)), b = labelSpotA(pts, mw(t_), rects, o)
    return b.a < b0.a ? { p: b.p, text: t_, a: b.a } : { p: b0.p, text: full, a: b0.a }
}
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): проба dev02 r4 — после «Типове розташування» (lanes) 3 пары подписей легли друг на друга: место каждой выбиралось только по узлам.
// Теперь подписи ставятся по очереди (порядок строк): место — вдоль своей линии, свободное и от узлов, и от уже поставленных подписей (их рамки — препятствия с весом 1,
// узлы — с весом NODE_K: подпись скорее ляжет на чужую подпись, чем на узел); не помещается — обрезка «…» по месту, как раньше. Пересчёт — после маршрутов всех рёбер
// (и в быстрой тяге — по всему списку: те же места, что у полного пересчёта). Меняются только рёбра, у которых изменились место или текст (новые объекты, _pts переносится).
const NODE_K = 1000
function placeLabels(edges, boxes, o, measureLabel) {
    const mw = (s) => (typeof measureLabel === 'function' ? measureLabel(s) : s.length * o.charW)
    const nodeRects = Object.values(boxes).map((b) => ({ ...rectOf(b, o.hitPad), k: NODE_K }))
    const out = edges.slice()
    const todo = out.map((e, i) => i).filter((i) => !out[i].loop && out[i]._pts && sg2EdgeLabel({ title: out[i].title, sign: out[i].sign }))
    if (!todo.length) return out
    // порядок постановки решает, кому достанется тесное место: пробуются по строкам и «короткие линии первыми» (у короткой — вертикальное ребро соседних узлов колонки,
    // пара вплотную — мест вдоль линии меньше), затем лучший из них с обрезанными / наложенными впереди; берётся лучший итог: меньше перекрытий (узлы, потом подписи), потом меньше обрезано
    const run = (order) => {
        const placed = [], fits = new Map()
        let area = 0, cut = 0
        for (const i of order) {
            const e = out[i], src = { title: e.title, sign: e.sign }
            const fit = sg2FitLabel(src, e._pts, placed.length ? nodeRects.concat(placed) : nodeRects, measureLabel, o)
            const hw = mw(fit.text) / 2 + o.labelPad
            placed.push({ x0: fit.p.x - hw, x1: fit.p.x + hw, y0: fit.p.y - o.labelH / 2, y1: fit.p.y + o.labelH / 2, k: 1 })
            fits.set(i, fit); area += fit.a; cut += sg2EdgeLabel(src).length - fit.text.length
        }
        return { fits, area, cut, order }
    }
    const better = (x, y) => !y || x.area < y.area - 1e-6 || (Math.abs(x.area - y.area) <= 1e-6 && x.cut < y.cut)
    const len = new Map(todo.map((i) => [i, Math.round(polyLen(out[i]._pts))]))
    let best = null
    for (const order of [todo.slice().sort((i, j) => out[i].index - out[j].index), todo.slice().sort((i, j) => len.get(i) - len.get(j) || out[i].index - out[j].index)]) {
        const r = run(order)
        if (better(r, best)) best = r
        if (best.area === 0 && best.cut === 0) break
    }
    if (best.area > 0 || best.cut > 0) {
        const src = (i) => sg2EdgeLabel({ title: out[i].title, sign: out[i].sign })
        const hard = best.order.filter((i) => best.fits.get(i).a > 0 || best.fits.get(i).text !== src(i))
        const r = run([...hard, ...best.order.filter((i) => !hard.includes(i))])
        if (better(r, best)) best = r
    }
    for (const [i, fit] of best.fits) {
        const e = out[i], lx = r1(fit.p.x), ly = r1(fit.p.y)
        if (e.lx === lx && e.ly === ly && e.lt === fit.text) continue
        out[i] = { ...e, lx, ly, lt: fit.text }
        Object.defineProperty(out[i], '_pts', { value: e._pts })
    }
    return out
}

// сетка обхода: клетка cell px, в клетке — число прямоугольников узлов (с зазором routePad), накрывающих её центр
function routeGrid(boxes, o) {
    const list = Object.entries(boxes).map(([id, b]) => ({ id, r: rectOf(b, o.routePad) }))
    let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity
    for (const { r } of list) { x0 = Math.min(x0, r.x0); y0 = Math.min(y0, r.y0); x1 = Math.max(x1, r.x1); y1 = Math.max(y1, r.y1) }
    let s = o.cell
    const M = 6 * s
    while (((x1 - x0 + 2 * M) / s) * ((y1 - y0 + 2 * M) / s) > 160000) s *= 1.5   // огромная схема — клетка крупнее (память и время A*)
    const gx = x0 - M, gy = y0 - M, C = Math.ceil((x1 - x0 + 2 * M) / s) + 1, R = Math.ceil((y1 - y0 + 2 * M) / s) + 1
    const cnt = new Uint8Array(C * R)
    const cells = (r) => [Math.max(0, Math.ceil((r.x0 - gx) / s)), Math.min(C - 1, Math.floor((r.x1 - gx) / s)), Math.max(0, Math.ceil((r.y0 - gy) / s)), Math.min(R - 1, Math.floor((r.y1 - gy) / s))]
    for (const { r } of list) { const [c0, c1, r0, r1] = cells(r); for (let y = r0; y <= r1; y++) for (let x = c0; x <= c1; x++) if (cnt[y * C + x] < 255) cnt[y * C + x]++ }
    return { s, gx, gy, C, R, cnt, used: new Uint8Array(C * R), cells, pt: (i) => ({ x: gx + (i % C) * s, y: gy + Math.floor(i / C) * s }) }
}
// A* по сетке от центра a до центра b: клетки a и b проходимы, чужие узлы — нет; 8 направлений без срезания углов, штраф за поворот и за клетки, занятые другими рёбрами;
// эвристика × 1,5 (взвешенный A*: путь почти кратчайший, перебор в разы меньше — замер на 26 узлах / 53 связях: модель 8–9 мс против 35–40)
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): strict — клетки, где поля обоих концов накрывают друг друга (узлы вплотную), закрыты: путь обходит, а не идёт напрямую сквозь щель уже стрелки
function gridPath(G, a, b, o, win, strict) {
    const { s, gx, gy, C, R, cnt, used } = G
    const own = new Uint8Array(C * R)
    for (const bx of [a, b]) { const [c0, c1, r0, r1] = G.cells(rectOf(bx, o.routePad)); for (let y = r0; y <= r1; y++) for (let x = c0; x <= c1; x++) own[y * C + x]++ }
    const free = strict ? (i) => own[i] < 2 && cnt[i] - own[i] <= 0 : (i) => cnt[i] - own[i] <= 0
    const cl = (v, n) => Math.max(0, Math.min(n - 1, v))
    const si = cl(Math.round((a.y - gy) / s), R) * C + cl(Math.round((a.x - gx) / s), C)
    const ti = cl(Math.round((b.y - gy) / s), R) * C + cl(Math.round((b.x - gx) / s), C)
    const tx = ti % C, ty = Math.floor(ti / C)
    // окно поиска: охват концов + win клеток (сначала узкое — быстро; не нашлось — вся сетка)
    const wx0 = win ? Math.min(si % C, tx) - win : 0, wx1 = win ? Math.max(si % C, tx) + win : C - 1
    const wy0 = win ? Math.min(Math.floor(si / C), ty) - win : 0, wy1 = win ? Math.max(Math.floor(si / C), ty) + win : R - 1
    const N = C * R, g = new Float32Array(N).fill(Infinity), came = new Int32Array(N).fill(-1), dir = new Int8Array(N).fill(-1), done = new Uint8Array(N)
    const D = [[1, 0], [-1, 0], [0, 1], [0, -1], [1, 1], [1, -1], [-1, 1], [-1, -1]]
    const h = (i) => { const dx = Math.abs((i % C) - tx), dy = Math.abs(Math.floor(i / C) - ty); return Math.max(dx, dy) + 0.414 * Math.min(dx, dy) }
    const heap = []   // двоичная куча [f, i]
    const pushH = (f, i) => { heap.push([f, i]); let k = heap.length - 1; while (k) { const p = (k - 1) >> 1; if (heap[p][0] <= heap[k][0]) break; [heap[p], heap[k]] = [heap[k], heap[p]]; k = p } }
    const popH = () => { const top = heap[0], last = heap.pop(); if (heap.length) { heap[0] = last; let k = 0; for (;;) { const l = 2 * k + 1, r = l + 1; let m = k; if (l < heap.length && heap[l][0] < heap[m][0]) m = l; if (r < heap.length && heap[r][0] < heap[m][0]) m = r; if (m === k) break; [heap[m], heap[k]] = [heap[k], heap[m]]; k = m } } return top }
    g[si] = 0; pushH(0, si)
    let steps = 0
    while (heap.length) {
        const [, i] = popH()
        if (done[i]) continue
        done[i] = 1
        if (i === ti) break
        if (++steps > N) return null
        const x = i % C, y = Math.floor(i / C)
        for (let d = 0; d < 8; d++) {
            const nx = x + D[d][0], ny = y + D[d][1]
            if (nx < 0 || ny < 0 || nx >= C || ny >= R || nx < wx0 || nx > wx1 || ny < wy0 || ny > wy1) continue
            const j = ny * C + nx
            if (done[j] || !free(j)) continue
            if (d >= 4 && (!free(y * C + nx) || !free(ny * C + x))) continue   // без срезания угла узла
            const cost = g[i] + (d >= 4 ? 1.414 : 1) + (dir[i] >= 0 && dir[i] !== d ? 0.6 : 0) + used[j] * 0.8
            if (cost < g[j]) { g[j] = cost; came[j] = i; dir[j] = d; pushH(cost + 1.5 * h(j), j) }
        }
    }
    if (!done[ti]) return null
    const cellsPath = []
    for (let i = ti; i >= 0; i = came[i]) { cellsPath.push(i); if (i === si) break }
    cellsPath.reverse()
    for (const i of cellsPath) if (used[i] < 250) used[i] += 3
    return cellsPath.map(G.pt)
}
// ломаная обхода: путь сетки → натянутая ломаная (центр a … центр b) → концы на границах прямоугольников → скругление углов; проверка — 0 касаний чужих узлов
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): ownR — свои прямоугольники (на 1 px внутрь); → {…, own: касания своих узлов}. Путь сетки идёт к центрам концов через их поля
// (клетки своих узлов проходимы), а соседние точки натяжка не проверяет — точка внутри своего узла попадала в ломаную, и конец ребра заходил внутрь узла (замер: 7 из 60 бросков
// узла вплотную к соседям на синтетике delta-nodes в lanes). Прежняя ломаная задела свой узел — вторая попытка: внутренние точки — только между последним выходом из узла-начала
// и первым входом в узел-конец, концы — там, где путь сетки пересекает границу (+ поле стрелки), натяжка проверяет и свои узлы. Ломаные без касаний своих — как были (побайтно)
function gridRoute(G, a, b, others, o, ownR = []) {
    const raw = gridPath(G, a, b, o, 24) || gridPath(G, a, b, o, 0)
    if (!raw || raw.length < 2) return null
    const first = pullRoute(raw, a, b, others, o, ownR, false)
    if (!ownR.length || (first && first.own === 0)) return first
    const alt = pullRoute(raw, a, b, others, o, ownR, true)
    if (alt && alt.own === 0) return alt
    // узлы вплотную (щель уже стрелки) — путь в обход щели
    const raw2 = gridPath(G, a, b, o, 0, true), alt2 = raw2 && raw2.length > 1 ? pullRoute(raw2, a, b, others, o, ownR, true) : null
    return alt2 && alt2.own === 0 ? alt2 : first || alt || alt2
}
// точка входа отрезка q (снаружи) → p (внутри) в прямоугольник узла n с полем pad; q уже в поле — q
function crossIn(q, p, n, pad) {
    const r = rectOf(n, pad)
    if (q.x >= r.x0 && q.x <= r.x1 && q.y >= r.y0 && q.y <= r.y1) return q
    const dx = p.x - q.x, dy = p.y - q.y, P = [-dx, dx, -dy, dy], Q = [q.x - r.x0, r.x1 - q.x, q.y - r.y0, r.y1 - q.y]
    let t0 = 0
    for (let i = 0; i < 4; i++) if (P[i] < 0) t0 = Math.max(t0, Q[i] / P[i])
    return { x: q.x + dx * Math.min(1, t0), y: q.y + dy * Math.min(1, t0) }
}
function pullRoute(raw, a, b, others, o, ownR, trim) {
    const ra = rectOf(a, -1), rb = rectOf(b, -1)
    let pts
    if (!trim) pts = [{ x: a.x, y: a.y }, ...raw.slice(1, -1), { x: b.x, y: b.y }]
    else {
        const inR = (p, n) => p.x > n.x - n.w / 2 && p.x < n.x + n.w / 2 && p.y > n.y - n.h / 2 && p.y < n.y + n.h / 2
        let s0 = 0, s1 = -1
        for (let i = 0; i < raw.length; i++) if (inR(raw[i], a)) s0 = i
        for (let i = s0 + 1; i < raw.length; i++) if (inR(raw[i], b)) { s1 = i; break }
        if (s1 < 0 || s1 - s0 < 2) return null
        pts = [crossIn(raw[s0 + 1], raw[s0], a, 2), ...raw.slice(s0 + 1, s1), crossIn(raw[s1 - 1], raw[s1], b, 4)]
    }
    const clear = (i, j) => {
        const rs = trim ? [...others, ra, rb] : i === 0 ? [...others, rb] : j === pts.length - 1 ? [...others, ra] : [...others, ra, rb]
        return sg2PolyHits([pts[i], pts[j]], rs) === 0
    }
    const pulled = [pts[0]]
    for (let i = 0; i < pts.length - 1;) {
        let j = pts.length - 1
        while (j > i + 1 && !clear(i, j)) j--
        pulled.push(pts[j]); i = j
    }
    if (pulled.length < (trim ? 2 : 3)) return null   // прямая центр—центр — это дуга с нулевым изгибом, её уже проверили
    const n = pulled.length
    if (!trim) {
        pulled[0] = rectEdgePoint(a.x, a.y, a.w, a.h, pulled[1].x, pulled[1].y)
        pulled[n - 1] = rectEdgePoint(b.x, b.y, b.w, b.h, pulled[n - 2].x, pulled[n - 2].y, 4)
    }
    let alt = null   // без касаний чужих, но со своими — запасной ответ
    for (const R0 of [o.cornerR, 0]) {   // скругление задело узел — острые углы
        let d = `M${r1(pulled[0].x)},${r1(pulled[0].y)}`
        const samp = [pulled[0]]
        for (let i = 1; i < n - 1; i++) {
            const u = pulled[i - 1], v = pulled[i], w = pulled[i + 1]
            const l1 = Math.hypot(v.x - u.x, v.y - u.y) || 1, l2 = Math.hypot(w.x - v.x, w.y - v.y) || 1
            const r = Math.min(R0, l1 * 0.45, l2 * 0.45)
            if (r < 1) { d += ` L${r1(v.x)},${r1(v.y)}`; samp.push(v); continue }
            const s1 = { x: v.x - ((v.x - u.x) / l1) * r, y: v.y - ((v.y - u.y) / l1) * r }, s2 = { x: v.x + ((w.x - v.x) / l2) * r, y: v.y + ((w.y - v.y) / l2) * r }
            d += ` L${r1(s1.x)},${r1(s1.y)} Q${r1(v.x)},${r1(v.y)} ${r1(s2.x)},${r1(s2.y)}`
            samp.push(...qPts(s1, v, s2, 2))
        }
        d += ` L${r1(pulled[n - 1].x)},${r1(pulled[n - 1].y)}`
        samp.push(pulled[n - 1])
        if (sg2PolyHits(samp, others) === 0) {
            const own = ownR.length ? sg2PolyHits(samp, ownR) : 0
            if (own === 0) return { d, pts: samp, p2: pulled[n - 1], from: pulled[n - 2], own }
            if (!alt) alt = { d, pts: samp, p2: pulled[n - 1], from: pulled[n - 2], own }
        }
    }
    return alt
}
// ---------- IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): наконечник стрелки ----------
// Было: линия (stroke шириной w, butt / round) доходила до самого острия многоугольника стрелки — у острия ширина стрелки 0, линия шире: на увеличении конец «тупой»
// (торец линии торчит по бокам острия; у выделенной связи, ширина ≥ 3, — сильнее). Выбор: наконечник остаётся многоугольником в координатах ребра (как было — цвет / CSS-переменная
// цвета связи и класс выделения работают без defs; SVG-маркер потребовал бы <marker> на каждый цвет и context-stroke, а при markerUnits strokeWidth рос бы с выделением),
// а видимая линия dl кончается внутри наконечника — там, где он уже шире линии (с запасом на выделение и круглый торец). Остриё и линия попадания (d) — на прежнем месте
export const SG2_SEL_W = 3   // ширина выделенной связи (edgeWidth компонента: Math.max(3, width))
export const sg2ArrowSize = (width) => 7 + ((Number(width) > 0 ? Number(width) : 1.6) - 1.6) * 1.5
// насколько укоротить линию у острия: ширина наконечника на расстоянии t от острия равна t (основание = длине) — линия шириной w (выделенная — не уже SG2_SEL_W)
// с круглым торцом (+ w / 2) скрыта при t ≥ 1,5 w; берём 1,6 w, но не меньше 0,45 и не больше 0,85 длины наконечника (линия не отрывается от его основания)
export function sg2ArrowTrim(size, width, selW = SG2_SEL_W) {
    const w = Math.max(Number(width) > 0 ? Number(width) : 0, selW)
    return r1(Math.min(size * 0.85, Math.max(size * 0.45, 1.6 * w)))
}
// путь d без последних T единиц по касательной в конце: конец сдвигается к предыдущей точке пути (контрольной точке Q / C, прошлой вершине L) — касательная та же;
// сдвиг не больше 0,9 расстояния до неё. Числа пути — пары «x,y» (так пишут sg2RouteEdges и schemeGraphErd)
export function sg2TrimPathEnd(d, T) {
    const s = str(d), n = Number(T)
    if (!s || !(n > 0)) return s
    const re = /(-?\d*\.?\d+(?:e[-+]?\d+)?),(-?\d*\.?\d+(?:e[-+]?\d+)?)/gi
    const ps = []
    let m
    while ((m = re.exec(s))) ps.push({ x: Number(m[1]), y: Number(m[2]), i: m.index, len: m[0].length })
    if (ps.length < 2) return s
    const a = ps[ps.length - 2], b = ps[ps.length - 1]
    const L = Math.hypot(b.x - a.x, b.y - a.y)
    if (!(L > 0)) return s
    const k = Math.min(n, L * 0.9) / L
    return s.slice(0, b.i) + `${r1(b.x - (b.x - a.x) * k)},${r1(b.y - (b.y - a.y) * k)}` + s.slice(b.i + b.len)
}
// наконечник у точки p (остриё), направление — от точки from; → { ax: точки многоугольника, size, trim }
export function sg2ArrowHead(p, from, width) {
    const size = sg2ArrowSize(width)
    return { ax: arrow(p, from, size), size, trim: sg2ArrowTrim(size, width) }
}
// boxes: {id: {x, y, w, h}}; → [{key, index, from, to, d, dl, ax, lx, ly, nx, ny, …стиль ребра, loop, bend, route}]; dl — видимая линия (конец под наконечником; без стрелки — d)
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): measureLabel — ширина текста подписи (svg-шрифт); у ребра — ломаная _pts (неперечисляемое: место подписи, быстрая тяга)
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): noLabels — без прохода подписей (быстрая тяга ставит их сама по всему списку рёбер)
export function sg2RouteEdges(edges, boxes, o = SG2, measureLabel, noLabels) {
    const out = []
    const pairs = new Map(), loops = new Map()
    for (const e of edges) {
        if (!boxes[e.from] || !boxes[e.to]) continue
        const m = e.loop ? loops : pairs
        const k = e.loop ? e.from : [e.from, e.to].sort().join('\u0001')
        if (!m.has(k)) m.set(k, [])
        m.get(k).push(e)
    }
    const allRects = Object.entries(boxes).map(([id, b]) => ({ id, r: rectOf(b, o.hitPad) }))
    const rectsOf = (skip) => allRects.filter((x) => !skip.includes(x.id)).map((x) => x.r)
    let G = null
    // geo: {d, pts (ломаная для подписи и знака), p2 (конец), from (точка, откуда смотрит стрелка)}
    const push = (e, geo, bend, loop, route) => {
        const L = polyLen(geo.pts) || 1
        const lt = loop ? '' : sg2EdgeLabel(e)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): подпись — на месте, свободном от узлов
        const mid = loop ? geo.mid : polyAt(geo.pts, 0.5)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): место и обрезка подписи — placeLabels после маршрутов всех рёбер (подписи не ложатся друг на друга)
        const nm = loop ? geo.nm : polyAt(geo.pts, Math.max(0.5, 1 - 24 / L))   // знак «−» (sign −1) — у конца, перед стрелкой
        let bx0 = Infinity, by0 = Infinity, bx1 = -Infinity, by1 = -Infinity
        for (const p of loop ? [geo.p0, geo.p2, geo.c, geo.c2] : geo.pts) { bx0 = Math.min(bx0, p.x); bx1 = Math.max(bx1, p.x); by0 = Math.min(by0, p.y); by1 = Math.max(by1, p.y) }
        const ah = e.arrow ? sg2ArrowHead(geo.p2, geo.from, e.width) : null   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
        out.push({ ...e, d: geo.d, dl: ah ? sg2TrimPathEnd(geo.d, ah.trim) : geo.d, ax: ah ? ah.ax : '', lx: r1(mid.x), ly: r1(mid.y), nx: r1(nm.x), ny: r1(nm.y), loop: !!loop, bend: r1(bend), route,
            bx0, bx1, by0, by1, lt })   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — место под подписи): lt — текст подписи на месте (обрезан «…», если не помещается)
        Object.defineProperty(out[out.length - 1], '_pts', { value: geo.pts })   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка)
    }
    const arcGeo = (geo) => ({ d: `M${r1(geo.p0.x)},${r1(geo.p0.y)} Q${r1(geo.c.x)},${r1(geo.c.y)} ${r1(geo.p2.x)},${r1(geo.p2.y)}`, pts: qPts(geo.p0, geo.c, geo.p2), p2: geo.p2, from: geo.c })
    for (const [, list] of pairs) {
        list.sort((x, y) => x.index - y.index)
        const rects = rectsOf([list[0].from, list[0].to])
        // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): проба dev02 r4 — при тяге «Узгоджений план» к Бюджету дуга consensus → budget заходила внутрь своего узла: узлы стояли близко, вершина дуги (c) — внутри Бюджета,
        // а касания проверялись только с чужими узлами. Теперь и свои прямоугольники (чуть внутрь: конец на границе — не касание) — препятствия: дуга не годится — другой изгиб / сторона,
        // затем ломаная; узлы пары накрывают друг друга — свои не проверяются (касание неизбежно). Свои — на 0,5 px внутрь: кривая проверяется ломаной с шагом 4 px
        const A0 = boxes[list[0].from], B0 = boxes[list[0].to]
        const ownR = Math.abs(A0.x - B0.x) < (A0.w + B0.w) / 2 && Math.abs(A0.y - B0.y) < (A0.h + B0.h) / 2 ? [] : [rectOf(A0, -0.5), rectOf(B0, -0.5)]
        let kf = 0, kb = 0
        for (const e of list) {
            const a = boxes[e.from], b = boxes[e.to]
            // вперёд — слева направо (одна колонка — сверху вниз); назад — обратное ребро, дугой ниже
            const forward = Math.abs(a.x - b.x) > 1 ? a.x < b.x : a.y <= b.y
            const len = Math.hypot(b.x - a.x, b.y - a.y) || 1
            const k = forward ? kf++ : kb++
            const sign = forward ? -1 : 1
            const base = Math.min(o.maxBend, forward ? (k === 0 ? 0 : o.fan * k) : (Math.min(0.16 * len + 12, o.backBend) + o.fan * k))
            // обход: дуга, задевшая чужой узел, — круче (шаг bendStep, не круче maxBend), на каждом шаге сначала своя сторона, затем другая; лучшая — по числу касаний
            let best = null
            const tries = []
            for (let bend = base; bend <= Math.max(base, o.maxBend) + 0.01; bend += o.bendStep) { tries.push([bend, sign]); if (bend > 0) tries.push([bend, -sign]) }
            for (const [bend, sg] of tries) {
                const geo = arc(a, b, bend, sg)
                const hx0 = Math.min(geo.p0.x, geo.c.x, geo.p2.x), hx1 = Math.max(geo.p0.x, geo.c.x, geo.p2.x), hy0 = Math.min(geo.p0.y, geo.c.y, geo.p2.y), hy1 = Math.max(geo.p0.y, geo.c.y, geo.p2.y)
                const near = rects.filter((r) => r.x1 > hx0 && r.x0 < hx1 && r.y1 > hy0 && r.y0 < hy1)   // кривая — внутри треугольника p0, c, p2
                const qp = near.length || ownR.length ? qPts(geo.p0, geo.c, geo.p2) : null
                const h = near.length ? sg2PolyHits(qp, near) : 0, ho = ownR.length ? sg2PolyHits(qp, ownR) : 0   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): ho — касания своих узлов
                if (!best || h < best.h || (h === best.h && ho < best.ho)) best = { geo, bend: bend * sg, h, ho }
                if (h === 0 && ho === 0) break
            }
            if (best.h > 0 || best.ho > 0) {   // ни одна дуга не обходит — ломаная по проходам между узлами
                if (!G) G = routeGrid(boxes, o)
                const gr = gridRoute(G, a, b, rects, o, ownR)
                if (gr && (gr.own === 0 || best.h > 0)) { push(e, gr, 0, false, 'grid'); continue }   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): ломаная — если без касаний своих узлов (или дуга задевает чужие)
            }
            push(e, arcGeo(best.geo), best.bend, false, best.h ? 'arc-hit' : 'arc')
        }
    }
    for (const [id, list] of loops) {
        list.sort((x, y) => x.index - y.index)
        list.forEach((e, k) => {   // петля над узлом, как у переходов (несколько — вложенные)
            const a = boxes[id], top = a.y - a.h / 2 - 2, R = o.loopR + o.loopStep * k
            const p0 = { x: a.x - 16, y: top }, p2 = { x: a.x + 16, y: top }
            const c1 = { x: a.x - 34 - 6 * k, y: top - R }, c2 = { x: a.x + 34 + 6 * k, y: top - R }
            const d = `M${r1(p0.x)},${r1(p0.y)} C${r1(c1.x)},${r1(c1.y)} ${r1(c2.x)},${r1(c2.y)} ${r1(p2.x)},${r1(p2.y)}`
            push(e, { p0, p2, c: c1, c2, d, from: c2, pts: [p0, p2], mid: { x: a.x, y: top - R * 0.75 - 2 }, nm: { x: a.x + 22 + 3 * k, y: top - R * 0.45 } }, -R, true, 'loop')
        })
    }
    return noLabels ? out : placeLabels(out, boxes, o, measureLabel)   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка)
}

// ---------- модель для svg ----------
// g — sg2Graph; auto — sg2AutoLayout; opts.layout — расстановка {ключ: {x, y}} (сохранённая / тяга; узла нет — авто); opts.width — ширина контейнера (viewBox не уже её —
// svg без масштабирования, при нехватке — прокрутка). → { W, H, x0, y0, nodes, frames, edges, layout }
export function sg2Model(g, auto, opts = {}) {
    const o = { ...SG2, ...(opts.geom || {}) }
    if (!g || !g.leaves.length) return null
    const lay = normalizeLayout(opts.layout)
    const pos = {}
    for (const l of g.leaves) {
        const q = lay && lay[layoutKey(l.id)]
        const p = q || (auto && auto[l.id]) || { x: 0, y: 0 }
        pos[l.id] = { x: r1(p.x), y: r1(p.y) }
    }
    const nodes = g.leaves.map((l) => ({ id: l.id, key: l.key, title: l.title, lines: l.lines, x: pos[l.id].x, y: pos[l.id].y, w: l.w, h: l.h, use: l.use, color: l.color, doc: l.doc, groups: l.groups }))
    const boxes = {}
    for (const n of nodes) boxes[n.id] = n
    const frames = sg2Frames(g, pos, o, opts.measureTitle)
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): быстрая тяга — opts.prev (модель прошлого кадра того же графа) и opts.moved (id тянущегося узла): заново — только рёбра узла и задевшие его место
    const inc = opts.prev && opts.moved != null ? sg2EdgesAfterMove(g, opts.prev, boxes, String(opts.moved), o, opts.measureLabel) : null
    const edges = inc ? inc.edges : sg2RouteEdges(g.edges, boxes, o, opts.measureLabel)
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity
    const grow = (x0, y0, x1, y1) => { minX = Math.min(minX, x0); minY = Math.min(minY, y0); maxX = Math.max(maxX, x1); maxY = Math.max(maxY, y1) }
    for (const n of nodes) grow(n.x - n.w / 2, n.y - n.h / 2, n.x + n.w / 2, n.y + n.h / 2)
    for (const f of frames) grow(f.x0, f.y0, f.x1, f.y1)
    for (const e of edges) grow(e.bx0, e.by0 - 8, e.bx1, e.by1 + 8)
    if (g.mode === 'lanes') {   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — колонки групп): подпись ребра соседних узлов колонки шире колонки — холст держит и её (у первой колонки не уходит за левый край)
        const mw = (s) => (typeof opts.measureLabel === 'function' ? opts.measureLabel(s) : s.length * o.charW)
        for (const e of edges) { const t_ = e.loop ? '' : sg2EdgeLabel(e); if (t_) { const hw = mw(t_) / 2 + o.labelPad; grow(e.lx - hw, e.ly - o.labelH / 2, e.lx + hw, e.ly + o.labelH / 2) } }
    }
    const x0 = Math.floor(minX - o.margin), y0 = Math.floor(minY - o.margin)
    const W = Math.max(Math.ceil(maxX + o.margin) - x0, Math.floor(Number(opts.width) || 0))
    const model = { W, H: Math.ceil(maxY + o.margin) - y0, x0, y0, nodes, frames, edges, layout: !!lay, rerouted: inc ? inc.rerouted : null }
    Object.defineProperty(model, '_g', { value: g })   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): граф, по которому построена модель (быстрая тяга — только тот же граф)
    return model
}
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы — полировка): рёбра после сдвига одного узла: ребро самого узла (вся его пара — веер) и ребро, ломаная которого задевает старое или новое место узла, —
// заново; остальные — объекты прошлого кадра. Сдвинулся не один узел, другой граф, нет ломаных — null (полный пересчёт). Итог тяги (pointerup) — полный пересчёт
export function sg2EdgesAfterMove(g, prev, boxes, moved, o = SG2, measureLabel) {
    if (!prev || prev._g !== g || !Array.isArray(prev.edges) || !Array.isArray(prev.nodes)) return null
    const ob = prev.nodes.find((n) => n.id === moved), nb = boxes[moved]
    if (!ob || !nb || prev.nodes.length !== Object.keys(boxes).length) return null
    for (const n of prev.nodes) { const b = boxes[n.id]; if (!b || (n.id !== moved && (b.x !== n.x || b.y !== n.y))) return null }
    const zone = [rectOf(ob, o.hitPad + 1), rectOf(nb, o.hitPad + 1)]
    const pk = (e) => (e.loop ? '\u0002' + e.from : [e.from, e.to].sort().join('\u0001'))
    const dirty = new Set()
    for (const e of prev.edges) {
        if (e.from === moved || e.to === moved || !e._pts) { dirty.add(pk(e)); continue }
        if (dirty.has(pk(e)) || !zone.some((z) => e.bx1 > z.x0 && e.bx0 < z.x1 && e.by1 > z.y0 && e.by0 < z.y1)) continue
        if (sg2PolyHits(e._pts, zone)) dirty.add(pk(e))
    }
    const fresh = new Map(sg2RouteEdges(g.edges.filter((e) => dirty.has(pk(e))), boxes, o, measureLabel, true).map((e) => [e.key, e]))
    return { edges: placeLabels(prev.edges.map((e) => fresh.get(e.key) || e), boxes, o, measureLabel), rerouted: fresh.size }   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как на слайде — полировка): подписи — по всему списку, как у полного пересчёта
}

// ---------- взаимное выделение ----------
// sel: {edge: индекс строки} | {node: id} | {group: gid} | null → { edges: Set(key), nodes: Set(id), frames: Set(gid), any }
export function sg2Highlight(model, sel) {
    const edges = new Set(), nodes = new Set(), frames = new Set()
    if (!model || !sel) return { edges, nodes, frames, any: false }
    if (sel.edge !== undefined && sel.edge !== null) {
        for (const e of model.edges) if (e.index === Number(sel.edge)) { edges.add(e.key); nodes.add(e.from); nodes.add(e.to) }
    } else if (sel.node) {
        nodes.add(String(sel.node))
        for (const e of model.edges) if (e.from === sel.node || e.to === sel.node) edges.add(e.key)
    } else if (sel.group) {
        frames.add(String(sel.group))
        const f = model.frames.find((x) => x.gid === sel.group)
        if (f) for (const n of model.nodes) if (n.groups.includes(f.gid)) nodes.add(n.id)
    }
    return { edges, nodes, frames, any: edges.size + nodes.size + frames.size > 0 }
}
// строка doc.edges (индекс) по строке грида: тот же объект; иначе — по ключу (концы + вид) с тем же порядковым номером среди строк грида
export function sg2EdgeIndexOf(rows, item, cfg, items) {
    if (!isObj(item) || !Array.isArray(rows)) return -1
    const i = rows.indexOf(item)
    if (i >= 0) return i
    const k = sg2RowKey(item, cfg)
    if (!k.split('\u0001').join('')) return -1
    const same = (Array.isArray(items) ? items : []).filter((it) => isObj(it) && sg2RowKey(it, cfg) === k)
    const n = Math.max(0, same.indexOf(item))
    let seen = 0
    for (let j = 0; j < rows.length; j++) if (sg2RowKey(rows[j], cfg) === k) { if (seen === n) return j; seen++ }
    return -1
}
// позиция строки грида (items — dataItem строк грида по порядку) для строки doc.edges с индексом index
export function sg2GridPosOfEdge(items, rows, index, cfg) {
    const row = Array.isArray(rows) ? rows[index] : null
    if (!isObj(row) || !Array.isArray(items)) return -1
    const i = items.indexOf(row)
    if (i >= 0) return i
    const k = sg2RowKey(row, cfg)
    let n = 0
    for (let j = 0; j < index; j++) if (sg2RowKey(rows[j], cfg) === k) n++
    for (let j = 0, seen = 0; j < items.length; j++) if (isObj(items[j]) && sg2RowKey(items[j], cfg) === k) { if (seen === n) return j; seen++ }
    return -1
}
// строка грида узлов → выделение графа: лист — {node}, группа — {group}; нет такого — null
export function sg2SelOfNodeItem(item, cfg, model) {
    if (!isObj(item) || !model) return null
    const key = keyOf(getPath(item, cfg.key_binding))
    if (!key) return null
    const n = model.nodes.find((x) => x.key === key)
    if (n) return { node: n.id }
    const f = model.frames.find((x) => x.key === key)
    return f ? { group: f.gid } : null
}
// позиция строки грида узлов по ключу узла / группы
export function sg2GridPosOfKey(items, key, cfg) {
    if (!key || !Array.isArray(items)) return -1
    for (let j = 0; j < items.length; j++) if (isObj(items[j]) && keyOf(getPath(items[j], cfg.key_binding)) === key) return j
    return -1
}

// ---------- IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): островок — масштаб осей, вписать, легенда ----------
// uiHelp-ключи кнопок масштаба (те же кнопки, что у AttrGraph; хранение другое — viewParams без пометки записи, поэтому свои объяснения)
export const SG2_HELP = Object.freeze({ stretchH: 'chart.schemeGraph.stretchH', squeezeH: 'chart.schemeGraph.squeezeH', stretchW: 'chart.schemeGraph.stretchW',
    squeezeW: 'chart.schemeGraph.squeezeW', fit: 'chart.schemeGraph.fit' })
export const SG2_SCALE_MIN = 0.2
export const SG2_SCALE_MAX = 8
// следующий множитель оси — как AttrGraph.scaleAxis: cur × f в пределах 0,2…8, около 1 (±0,02) — ровно 1
export function sg2ScaleNext(cur, f) {
    let v = Math.max(SG2_SCALE_MIN, Math.min(SG2_SCALE_MAX, scaleNum(cur) * scaleNum(f)))
    if (Math.abs(v - 1) < 0.02) v = 1
    return Math.round(v * 10000) / 10000
}
// имя графа в viewParams (store.get_viewParam / set_viewParam): attr.name, иначе id
export const sg2ViewName = (attr) => (attr && (attr.name || attr.id)) || ''
// множители осей из viewParams.<граф>.graph_scale_x / _y (ключи — как doc.params AttrGraph); нет / не число — 1
export function sg2ViewScale(store, WIDGET, attr) {
    const name = sg2ViewName(attr)
    if (!store || typeof store.get_viewParam !== 'function' || !WIDGET || !WIDGET.record || !name) return { fx: 1, fy: 1 }
    try { return { fx: scaleNum(store.get_viewParam(WIDGET, name, 'graph_scale_x', null, attr)), fy: scaleNum(store.get_viewParam(WIDGET, name, 'graph_scale_y', null, attr)) } } catch (e) { return { fx: 1, fy: 1 } }
}
// растянуть / сжать по оси: настройка вида — store.set_viewParam(…, set_modified = false), как выбор поля шахматки (crossGridV2.cg2SetField) и «Classic / Lens» графа:
// запись НЕ помечается изменённой (Save не загорается), на бэк уходит с ближайшим Save записи. → новый множитель (null — некуда писать)
export function sg2SetScale(store, WIDGET, attr, axis, f) {
    const name = sg2ViewName(attr)
    if (!store || typeof store.set_viewParam !== 'function' || !WIDGET || !WIDGET.record || !name) return null
    const cur = sg2ViewScale(store, WIDGET, attr)[axis === 'x' ? 'fx' : 'fy']
    const v = sg2ScaleNext(cur, f)
    store.set_viewParam(WIDGET, name, axis === 'x' ? 'graph_scale_x' : 'graph_scale_y', v, attr, false)
    return v
}
// «вписать»: множители сброшены (null — как удалённые у AttrGraph.zoomFit), тоже без пометки записи
export function sg2ResetScale(store, WIDGET, attr) {
    const name = sg2ViewName(attr)
    if (!store || typeof store.set_viewParam !== 'function' || !WIDGET || !WIDGET.record || !name) return false
    for (const k of ['graph_scale_x', 'graph_scale_y']) {
        const cur = store.get_viewParam(WIDGET, name, k, null, attr)
        if (cur !== null && cur !== undefined) store.set_viewParam(WIDGET, name, k, null, attr, false)
    }
    return true
}
// сохранённая расстановка в масштабе осей: {ключ: {x × fx, y × fy}}; inverse — обратно (тяга пишет расстановку в масштабе 1). Масштаб от начала координат: viewBox идёт за габаритом
// (x0 / y0 — край содержимого), поэтому на экране это то же, что масштаб от центра, а обратное преобразование точное при любой тяге. Множители 1 / не объект — тот же объект
export function sg2ScaleLayout(lay, scale, inverse) {
    const { fx, fy } = scaleOf(scale)
    if (!isObj(lay) || (fx === 1 && fy === 1)) return lay
    const kx = inverse ? 1 / fx : fx, ky = inverse ? 1 / fy : fy
    const out = {}
    for (const [k, p] of Object.entries(lay)) {
        const x = Number(p && p.x), y = Number(p && p.y)
        out[k] = isObj(p) && Number.isFinite(x) && Number.isFinite(y) ? { ...p, x: r1(x * kx), y: r1(y * ky) } : p
    }
    return out
}
// размер svg: обычно 1:1 (шире контейнера — прокрутка); «вписать» (fit) — в ширину контейнера, высота по пропорции viewBox (без прокрутки). → { w, h, k }
export function sg2FitBox(model, width, fit) {
    if (!model) return { w: 0, h: 0, k: 1 }
    const cw = Math.floor(Number(width) || 0)
    if (!fit || !(cw > 0) || model.W <= cw) return { w: model.W, h: model.H, k: 1 }
    const k = cw / model.W
    return { w: cw, h: Math.max(1, Math.round(model.H * k)), k }
}
// легенда видов связей: по умолчанию скрыта (как окно легенды AttrGraph — mapLegendVisible: false); выбор живёт на объекте виджета в памяти сессии (WIDGET._sg2LegendOn[id графа],
// как WIDGET._activeTabByPanel): переживает перемонтирование вкладки, в запись не пишется (Save не загорается), на бэк не уходит
export function sg2LegendOn(WIDGET, id) {
    try { return !!(WIDGET && WIDGET._sg2LegendOn && WIDGET._sg2LegendOn[String(id)] === true) } catch (e) { return false }
}
export function sg2LegendSet(WIDGET, id, on) {
    if (!WIDGET || typeof WIDGET !== 'object') return false
    try { const m = WIDGET._sg2LegendOn || (WIDGET._sg2LegendOn = {}); m[String(id)] = !!on; return true } catch (e) { return false }
}

// ---------- IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы): «Add node» / «Add link» островка и меню правой кнопки, «Delete link», откат ----------
// Слово Игоря 25.10 ≈18:40Z: «кнопка добавить узел и кнопка добавить связь; … пока ховер — связь идёт к точке мыши либо к элементу под мышью (предпросмотр); те же действия
// в меню по правой кнопке». Контракт — ie-dm7 plan_map/SPEC.md «правка на графе»: params editable, nodes_create_defaults, edges_create_defaults. Строки пишутся в табличные
// части записи как у шахматки (массив записи на месте, запись помечается изменённой — Save общий), откат — журнал графа (точный: та же строка на то же место).
// Свой выключатель (§8, дефолт ВКЛ, без пересборки); выкл — без кнопок и меню
export const SG2_EDIT_FLAG = 'fe.ux.schemeGraphEdit'
export function sg2EditOn(setting) {
    try { return (typeof setting === 'function' ? setting(SG2_EDIT_FLAG, true) : true) !== false } catch (e) { return true }
}
const jclone = (v) => (v === undefined ? undefined : JSON.parse(JSON.stringify(v)))
const flagOf = (v) => v === true || v === 'true' || v === 1
// значение по пути 'a.b' (промежуточные объекты создаются)
export function sg2SetPath(obj, path, value) {
    const parts = str(path).split('.').filter(Boolean)
    if (!isObj(obj) || !parts.length) return obj
    let cur = obj
    for (let i = 0; i < parts.length - 1; i++) { if (!isObj(cur[parts[i]])) cur[parts[i]] = {}; cur = cur[parts[i]] }
    cur[parts[parts.length - 1]] = value
    return obj
}
// параметры правки (ключи атрибута, запасной — attr.params, как sg2Config): editable (true / 'true'), умолчания новых строк — копии объектов (не объект — {})
export function sg2EditConfig(attr) {
    const a = isObj(attr) ? attr : {}, p = isObj(a.params) ? a.params : {}
    const pick = (k) => (a[k] !== undefined ? a[k] : p[k])
    const obj = (k) => { const v = pick(k); return isObj(v) ? jclone(v) : {} }
    return { editable: flagOf(pick('editable')), nodes_create_defaults: obj('nodes_create_defaults'), edges_create_defaults: obj('edges_create_defaults') }
}
// правка доступна: выключатель, editable атрибута и право на запись (роль «только чтение», виджет / атрибут только для чтения — нет)
export function sg2CanEdit(o = {}) { return !!(o && o.on && o.editable && !o.readonly && !o.widgetReadOnly && !o.attrReadOnly) }
// все ключи doc.nodes — узлы и группы по всей иерархии
export function sg2NodeKeys(rows, cfg) {
    const out = new Set()
    const walk = (list) => (Array.isArray(list) ? list : []).forEach((row) => {
        if (!isObj(row)) return
        const k = keyOf(getPath(row, cfg.key_binding))
        if (k) out.add(k)
        const kids = cfg.children_path ? getPath(row, cfg.children_path) : undefined
        if (Array.isArray(kids)) walk(kids)
    })
    walk(rows)
    return out
}
// ключ нового узла: new-node-N, N — первый свободный среди ключей doc.nodes (с 1)
export const SG2_NEW_NODE = 'new-node-'
export function sg2NewNodeName(rows, cfg, prefix = SG2_NEW_NODE) {
    const keys = sg2NodeKeys(rows, cfg)
    let n = 1
    while (keys.has(prefix + n)) n++
    return prefix + n
}
// рамка группы под точкой svg: самая внутренняя (глубже; при равной глубине — меньшая); вне рамок — null
export function sg2FrameAt(frames, x, y) {
    let best = null
    for (const f of Array.isArray(frames) ? frames : []) {
        if (!f || !(x >= f.x0 && x <= f.x1 && y >= f.y0 && y <= f.y1)) continue
        const area = (f.x1 - f.x0) * (f.y1 - f.y0)
        if (!best || f.depth > best.f.depth || (f.depth === best.f.depth && area < best.area)) best = { f, area }
    }
    return best ? best.f : null
}
// строка группы по gid ('g:0.2' — путь collectNodes: верхний уровень — индекс в списке, вложенные — среди объектов children_path); нет — null
export function sg2RowAtGid(rows, gid, cfg) {
    const m = /^g:(\d+(?:\.\d+)*)$/.exec(str(gid))
    if (!m) return null
    const path = m[1].split('.').map(Number)
    let list = Array.isArray(rows) ? rows : [], row = null
    for (let d = 0; d < path.length; d++) {
        row = list[path[d]]
        if (!isObj(row)) return null
        if (d < path.length - 1) { const k = cfg.children_path ? getPath(row, cfg.children_path) : undefined; list = Array.isArray(k) ? k.filter(isObj) : [] }
    }
    return row
}
// новая строка doc.nodes: ключ, название, use: true, node — пустая ссылка на элемент системы (AttrLink), затем nodes_create_defaults (ключ, название и children_path не перекрывают)
export function sg2NodeRow(title, name, cfg, defaults) {
    const row = {}
    sg2SetPath(row, cfg.key_binding || 'name', str(name))
    sg2SetPath(row, cfg.nodes_title_binding || 'title', str(title).trim())
    if (cfg.nodes_use_binding) sg2SetPath(row, cfg.nodes_use_binding, true)
    if (cfg.nodes_link_binding) sg2SetPath(row, cfg.nodes_link_binding, { attr_type: 'AttrLink', relation_segment: '', value: '', valueStr: '' })
    const own = new Set([cfg.key_binding || 'name', cfg.nodes_title_binding || 'title', cfg.children_path].filter(Boolean))
    for (const [k, v] of Object.entries(isObj(defaults) ? defaults : {})) if (!own.has(k)) sg2SetPath(row, k, jclone(v))
    return row
}
// новая строка doc.edges: концы {name} по edges_source_binding / edges_target_binding ('source.name' → {source: {name}}), затем edges_create_defaults (концов не перекрывают)
export function sg2EdgeRow(src, tgt, cfg, defaults) {
    const sb = cfg.edges_source_binding || 'source.name', tb = cfg.edges_target_binding || 'target.name'
    const row = {}
    sg2SetPath(row, sb, str(src))
    sg2SetPath(row, tb, str(tgt))
    const own = new Set([sb.split('.')[0], tb.split('.')[0]])
    for (const [k, v] of Object.entries(isObj(defaults) ? defaults : {})) if (!own.has(k.split('.')[0])) sg2SetPath(row, k, jclone(v))
    return row
}
// новую связь можно создать: '' — да; 'empty' — нет конца; 'loop' — узел сам на себя; 'dup' — уже есть строка с той же парой и тем же видом (sg2RowKey)
export function sg2EdgeCheck(rows, src, tgt, cfg, defaults) {
    const s = keyOf(src), t_ = keyOf(tgt)
    if (!s || !t_) return 'empty'
    if (s === t_) return 'loop'
    const k = sg2RowKey(sg2EdgeRow(s, t_, cfg, defaults), cfg)
    return (Array.isArray(rows) ? rows : []).some((r) => isObj(r) && sg2RowKey(r, cfg) === k) ? 'dup' : ''
}
// вид новой связи (стиль резиновой линии): вид из edges_create_defaults, нет его в edge_kinds — default-вид
export function sg2NewEdgeKind(kinds, cfg, defaults) {
    const K = kinds || sg2Kinds([], '')
    const id = cfg && cfg.edge_kind_binding ? keyOf(getPath(isObj(defaults) ? defaults : {}, cfg.edge_kind_binding)) : ''
    return (id && K.byId && K.byId.get(id)) || K.def
}
// узел под точкой svg (верхний — последний в списке, как в DOM); pad — запас по краю; нет — ''
export function sg2NodeAt(model, x, y, pad = 0) {
    const list = model && Array.isArray(model.nodes) ? model.nodes : []
    for (let i = list.length - 1; i >= 0; i--) {
        const n = list[i]
        if (Math.abs(x - n.x) <= n.w / 2 + pad && Math.abs(y - n.y) <= n.h / 2 + pad) return n.id
    }
    return ''
}
// клиентские координаты → svg: viewBox x0 / y0, масштаб — ширина viewBox к ширине svg на экране (1:1 и «вписать»; preserveAspectRatio meet — тот же по обеим осям)
export function sg2ClientToSvg(model, rect, cx, cy) {
    if (!model || !rect) return null
    const k = model.W && rect.width > 0 ? model.W / rect.width : 1
    return { x: r1(model.x0 + (cx - rect.left) * k), y: r1(model.y0 + (cy - rect.top) * k) }
}
// резиновая линия связи от узла src к точке p: над другим узлом — к его центру (target — его id), над самим src или пустым местом — к точке; стрелка у края цели / у точки
export function sg2RubberLine(model, srcId, p, pad = 2) {
    const nodes = model && Array.isArray(model.nodes) ? model.nodes : []
    const s = nodes.find((n) => n.id === srcId)
    if (!s || !p) return null
    const hit = sg2NodeAt(model, p.x, p.y, pad)
    const t_ = hit && hit !== srcId ? nodes.find((n) => n.id === hit) : null
    const x2 = t_ ? t_.x : r1(p.x), y2 = t_ ? t_.y : r1(p.y)
    const tip = t_ ? rectEdgePoint(t_.x, t_.y, t_.w, t_.h, s.x, s.y, 3) : { x: x2, y: y2 }
    const near = Math.hypot(tip.x - s.x, tip.y - s.y) > 8
    return { x1: s.x, y1: s.y, x2, y2, target: t_ ? t_.id : '', ax: near ? arrow(tip, { x: s.x, y: s.y }) : '' }
}
// расстановка с новым узлом id в точке p (масштаб осей scale), в масштабе 1: остальные узлы — с текущих мест (без этого авторасстановка с новым узлом сдвинула бы их)
export function sg2LayoutWithNode(model, id, p, scale) {
    const out = {}
    for (const nd of model && Array.isArray(model.nodes) ? model.nodes : []) out[layoutKey(nd.id)] = { x: r1(nd.x), y: r1(nd.y) }
    if (id !== undefined && id !== null && p) out[layoutKey(id)] = { x: r1(p.x), y: r1(p.y) }
    return sg2ScaleLayout(out, scale, true)
}
// запись помечается изменённой — как AttrCrossGrid.markModified: служебная таблица (_doc.*) — нет; каскад на родителей widget-row (до 5 уровней)
export function sg2MarkModified(store, WIDGET, binding) {
    if (!store || !WIDGET || !isObj(WIDGET.record)) return false
    const svc = (b) => typeof store.is_serviceBinding === 'function' && store.is_serviceBinding(b)
    if (svc(binding)) return false
    const mark = (rec) => { rec._meta = rec._meta || {}; rec._meta.modified = true; rec._meta.calced = false }
    mark(WIDGET.record)
    let W = WIDGET, i = 0
    while (W && W.widget === 'widget-row' && W.parentWIDGET && W.parentWIDGET.id !== undefined && i++ < 5) {
        const mb = str(W.record && W.record._meta && W.record._meta.binding)
        const pw = typeof store.findWidget === 'function' ? store.findWidget(W.parentWIDGET.id) : null
        const parent = pw && pw.WIDGET
        if (!parent || !isObj(parent.record) || !mb || svc(mb)) break
        mark(parent.record)
        W = parent
    }
    return true
}
// ---------- журнал отката правок графа ----------
// запись { op: 'insert' | 'remove', table: 'nodes' | 'edges', arr — массив записи со строкой, item — сама строка, index — её место, root — массив таблицы записи (сверка),
// layout: { before, after } | null, label }. insert: вперёд — вставить, назад — убрать; remove — наоборот. Строки ищутся по ссылке (место — запасное)
export function sg2RowInsert(arr, item, index) {
    if (!Array.isArray(arr) || !isObj(item) || arr.indexOf(item) >= 0) return false
    arr.splice(Math.min(Math.max(0, Number(index) || 0), arr.length), 0, item)
    return true
}
export function sg2RowRemove(arr, item) {
    if (!Array.isArray(arr)) return false
    const i = arr.indexOf(item)
    if (i < 0) return false
    arr.splice(i, 1)
    return true
}
export function sg2JournalApply(e, dir) {
    if (!e) return false
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: меню графа — виджет строки, удаление, раскладка по умолчанию): пакет (удаление узла с его связями) — шаги по порядку вперёд, назад — в обратном; шаг не применим — false (журнал очищается)
    if (e.op === 'batch') {
        const st = Array.isArray(e.steps) ? e.steps : []
        for (const s of dir === 'undo' ? [...st].reverse() : st) if (!sg2JournalApply(s, dir)) return false
        return st.length > 0
    }
    const ins = (e.op === 'insert') === (dir !== 'undo')
    return ins ? sg2RowInsert(e.arr, e.item, e.index) : sg2RowRemove(e.arr, e.item)
}
export function sg2EditJournal(limit = 200) {
    const undo = [], redo = []
    const clear = () => { undo.length = 0; redo.length = 0 }
    return {
        undo, redo, clear,
        record(e) { undo.push(e); if (undo.length > limit) undo.shift(); redo.length = 0 },
        // шаг назад / вперёд: apply(e, dir) → false (строки уже нет / она уже на месте) — журнал не сходится с данными: очищается
        step(dir, apply) {
            const from = dir === 'undo' ? undo : redo, to = dir === 'undo' ? redo : undo
            const e = from.pop()
            if (!e) return null
            if (!(typeof apply === 'function' ? apply(e, dir) : sg2JournalApply(e, dir))) { clear(); return null }
            to.push(e)
            return e
        },
        // массив таблицы записи сменился (запись перечитана) — журнал недействителен: очищается. → есть ли шаги
        valid(rootOf) {
            if ([...undo, ...redo].some((e) => typeof rootOf === 'function' && (rootOf(e.table) !== e.root || Object.entries(e.roots || {}).some(([tb, r]) => rootOf(tb) !== r)))) clear()   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: меню графа — виджет строки, удаление, раскладка по умолчанию): + roots пакета
            return undo.length + redo.length > 0
        },
    }
}

// ---------- IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы — цвет связей, виджет строки по клику) ----------
// A. Слово Игоря 25.10 ≈20:45Z (через ie-dm7 #104861; бэк main fee5b35f4 — params edges_color_binding: 'color'): непустой цвет строки doc.edges — поверх цвета вида EDGE-KIND
// (линия, стрелка, знак «−», подпись); пусто / не цвет ('#RGB', '#RRGGBB', 'RRGGBB', rgb(); имя — нет) — цвет вида, как было. Легенда — виды, как есть. Подпись — тот же тон,
// затемнённый до контраста ≥ 4,5 с фоном (sg2Readable, как подписи узлов), тёмная тема — переменная к обращённому фону. Выключатель — fe.ux.schemeGraphColors (выкл — цвет вида)
export function sg2EdgeOwn(row, cfg) { return isObj(row) && cfg && cfg.edges_color_binding ? sg2Hex(getPath(row, cfg.edges_color_binding)) : '' }
// граф → { ключ связи: { color, style } } — только связи со своим цветом; --sg2-ec линия / стрелка, --sg2-el / --sg2-eld подпись и знак «−» (светлая / тёмная тема); выкл — пусто
export function sg2EdgePaint(g, on) {
    const out = {}
    if (!g || !on) return out
    for (const e of g.edges || []) {
        const c = sg2Hex(e && e.own)
        if (c) out[e.key] = { color: c, style: { '--sg2-ec': c, '--sg2-el': sg2Readable(c), '--sg2-eld': sg2Inv(sg2Readable(sg2Inv(c), sg2Inv(SG2_BG))) } }
    }
    return out
}
// B. Слово Игоря 25.10 ≈19:15Z (через ie-dm7 #104825 п.2): «клик по узлу → виджет строки doc.nodes, клик по ребру → виджет строки doc.edges, с правкой (выделение ↔ грид остаётся)»,
// «openRowWidget, как у AttrGraph v1». Строка — объект табличной части записи (узел / группа — по пути collectNodes, дубли ключей различаются; связь — по индексу строки);
// форма строки (widget-row) правит её поля в записи (binding.iroot.поле), Save общий. Свой выключатель (§8, дефолт ВКЛ, без пересборки); выкл — только выделение, как было
export const SG2_ROWW_FLAG = 'fe.ux.schemeGraphRowWidget'
export function sg2RowWidgetOn(setting) {
    try { return (typeof setting === 'function' ? setting(SG2_ROWW_FLAG, true) : true) !== false } catch (e) { return true }
}
// окно двойного клика по узлу (dragEnd: второй клик за 400 мс — запись элемента системы): карточка узла с записью — после него (двойной клик её отменяет), без записи — сразу
export const SG2_ROWW_DELAY = 400
export function sg2RowOpenDelay(nd, ms = SG2_ROWW_DELAY) { return nd && isObj(nd.doc) && nd.doc.id ? ms : 0 }
// kind 'edge' (item.index) | 'node' (item.id модели) | 'group' (item.gid) → { which: 'edges' | 'nodes', binding, row } — живой объект строки табличной части; нет — null
export function sg2RowTarget(kind, item, g, nodesRows, edgesRows, cfg) {
    if (!isObj(item) || !isObj(cfg)) return null
    if (kind === 'edge') {
        const i = Number(item.index), row = Array.isArray(edgesRows) && Number.isInteger(i) && i >= 0 ? edgesRows[i] : null
        return isObj(row) && cfg.edges_binding ? { which: 'edges', binding: cfg.edges_binding, row } : null
    }
    if (!g || !g.nodes || !cfg.nodes_binding) return null
    let path = null
    if (kind === 'node') { const l = (g.nodes.leaves || []).find((x) => sg2NodeId(x) === str(item.id)); path = l ? l.path : null }
    else if (kind === 'group') { const gid = str(item.gid); path = gid.startsWith('g:') ? gid.slice(2) : null }
    const row = path != null ? sg2RowsByPath(nodesRows, cfg).get(str(path)) : null
    return isObj(row) ? { which: 'nodes', binding: cfg.nodes_binding, row } : null
}
// действие открытия формы строки — как AttrGraph.openRowWidget (справа, чтобы не закрывать граф); selectedRow — { iroot, dataItem, x, y }
export function sg2RowAction(title, binding, attrs, selectedRow) {
    return { tooltip: title, action_name: 'action-front-openLine-graphRow-2026-09-06',
        widgetRow_params: { width_pct: 0.44, height_pct: 0.5, top_pct: 0.08, left_pct: 0.54 },
        command: 'widget_open', widget: 'widget-row', get_currentRow: true, get_Parent: true, open_in_children_widget: true, cssClass: 'pi p-button-white pi-pencil',
        source_attr_type: 'AttrSchemeGraphV2', binding, attrs: Array.isArray(attrs) ? attrs : [], selectedRow }
}

// ---------- IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов) ----------
// грид таблицы скрыт и его обновление отложено до показа (AttrGrid.gdr_busy, fe.ux.gridDeferredRefresh) — строки в нём старые: выбор строки из графа ждёт показа
export function sg2GridBusy(g) {
    try { return !!(g && typeof g.gdr_busy === 'function' && g.gdr_busy()) } catch (e) { return false }
}
// цвет нового узла (проба dev02: новый узел — без цвета и рамки среди цветных соседей): цвет группы, куда он ставится (nodes_color_binding); у группы нет — первого соседа-листа
// с цветом; затем — ближайшей группы выше. Умолчания nodes_create_defaults задают цвет — '' (их цвет); нет поля цвета / узел вне групп / не цвет — ''. Значение — как в строке-источнике
export function sg2NewNodeColor(rows, gid, cfg, defaults) {
    const b = cfg && cfg.nodes_color_binding
    if (!b) return ''
    const dv = isObj(defaults) ? getPath(defaults, b) : undefined
    if (dv !== undefined && dv !== null && dv !== '') return ''
    const m = /^g:(\d+(?:\.\d+)*)$/.exec(str(gid))
    if (!m) return ''
    const kidsOf = (row) => { const k = cfg.children_path ? getPath(row, cfg.children_path) : undefined; return Array.isArray(k) ? k.filter(isObj) : [] }
    const chain = []
    let list = Array.isArray(rows) ? rows : []
    for (const i of m[1].split('.').map(Number)) { const row = list[i]; if (!isObj(row)) return ''; chain.push(row); list = kidsOf(row) }   // путь — как sg2RowAtGid
    const own = (row) => { const v = getPath(row, b); return sg2Hex(v) ? v : '' }
    const grp = chain[chain.length - 1]
    if (own(grp)) return own(grp)
    for (const k of kidsOf(grp)) if (!kidsOf(k).length && own(k)) return own(k)
    for (let i = chain.length - 2; i >= 0; i--) if (own(chain[i])) return own(chain[i])
    return ''
}

// ---------- IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — поиск, настройки, dragDrop) ----------
// шестерёнка графа схемы: флажки AttrGraph, применимые к схеме (utils/graphPanel.js — почему остальные нет), и вид раскладки поверх layout_mode бэка — всё в viewParams без пометки записи
export const SG2_QS_KEYS = Object.freeze(['graph_edge_arrows', 'graph_hide_unused', 'graph_hover_neighbors'])
export const SG2_QS_HELP = 'chart.schemeGraph.qs.'
// бэк задал вид раскладки (attr.layout_mode / params.layout_mode — непустая строка): тогда в шестерёнке есть переключатель «Node layout»
export function sg2LayoutModeGiven(attr) {
    const a = isObj(attr) ? attr : {}, p = isObj(a.params) ? a.params : {}
    const v = typeof a.layout_mode === 'string' ? a.layout_mode : typeof p.layout_mode === 'string' ? p.layout_mode : ''
    return !!v.trim()
}
// вид раскладки: viewParams.<граф>.layout_mode ('lanes' | 'layers') поверх layout_mode бэка (cur); иное / нет — cur
export function sg2ViewLayoutMode(store, WIDGET, attr, cur) {
    const name = sg2ViewName(attr)
    if (!store || typeof store.get_viewParam !== 'function' || !WIDGET || !WIDGET.record || !name) return cur
    let v = null
    try { v = store.get_viewParam(WIDGET, name, 'layout_mode', null, attr) } catch (e) { v = null }
    const m = typeof v === 'string' ? v.trim().toLowerCase() : ''
    return m === 'lanes' || m === 'layers' ? m : cur
}
// «Hide unused (use = false)»: граф без выключенных узлов и связей (и связей к выключенным узлам); группы и колонки без узлов уходят. Индексы строк связей (e.index) и
// g.nodes (поиск строки узла для карточки и правки) не меняются. Нечего прятать — тот же объект (кэш раскладки не сбрасывается)
export function sg2HideUnused(g) {
    if (!g || !Array.isArray(g.leaves)) return g
    const offN = g.leaves.filter((l) => l.use === false).length, offE = (g.edges || []).filter((e) => e.use === false).length
    if (!offN && !offE) return g
    const keep = new Set(g.leaves.filter((l) => l.use !== false).map((l) => l.id))
    const groups = (g.groups || []).map((x) => ({ ...x, leaves: (x.leaves || []).filter((id) => keep.has(id)) })).filter((x) => x.leaves.length)
    const lanes = Array.isArray(g.lanes) ? g.lanes.map((ln) => ({ ...ln, leaves: ln.leaves.filter((id) => keep.has(id)) })).filter((ln) => ln.leaves.length) : g.lanes
    const edges = (g.edges || []).filter((e) => e.use !== false && keep.has(e.from) && keep.has(e.to))
    return { ...g, leaves: g.leaves.filter((l) => keep.has(l.id)), groups, lanes, edges, hidden: { nodes: offN, edges: (g.edges || []).length - edges.length } }
}
// graph-eval графа — как AttrGraph: doc.params['graph-eval'] записи, иначе attr.graphEval (строка JSON / объект) → объект ({} — нет / не читается)
export function sg2GraphEval(store, WIDGET, attr) {
    const p = WIDGET && WIDGET.record && WIDGET.record.doc && isObj(WIDGET.record.doc.params) ? WIDGET.record.doc.params : {}
    const raw = p['graph-eval'] || (isObj(attr) ? attr.graphEval : '') || ''
    if (isObj(raw)) return raw
    if (typeof raw !== 'string' || !raw.trim()) return {}
    try { const v = store && typeof store.str_toJSON === 'function' ? store.str_toJSON(WIDGET, raw) : JSON.parse(raw); return isObj(v) ? v : {} } catch (e) { return {} }
}
// тяга узлов: command-dragDrop (имя команды AttrGraph) — в graph-eval, в атрибуте или в его params. У AttrGraph тяга по умолчанию ВЫКЛ (нужен use: true); у схемы — ВКЛ
// (тяга была до тулбара, принято ie-dm7 #104786): выключает только явное false / { use: false }; true / { use: true } — вкл; первое заданное по порядку источников — решает
export function sg2DragOn(evalParams, attr) {
    const a = isObj(attr) ? attr : {}
    const src = [isObj(evalParams) ? evalParams['command-dragDrop'] : undefined, a['command-dragDrop'], isObj(a.params) ? a.params['command-dragDrop'] : undefined]
    for (const v of src) {
        if (v === false || v === 'false') return false
        if (v === true || v === 'true') return true
        if (isObj(v) && v.use !== undefined) return !(v.use === false || v.use === 'false')
    }
    return true
}

// ---------- IE 2026 10 25 / ODOO-348925 (заказ Игоря: меню графа — виджет строки, удаление, раскладка по умолчанию) ----------
// Слово Igor 25.10 ≈21:55Z (через ie-dm7 #104932): 1) «Віджет рядка» — пунктом меню узла / связи (и заголовка группы); пока виджет строки открыт, клик по другому узлу / связи
// переключает его на их строку (следящий режим); закрыл пользователь — сам больше не открывается, только снова пунктом меню; простой клик карточку не открывает — только выделяет.
// 2) «Видалити вузол» (строка doc.nodes и все связи, где узел — source или target) и «Видалити зв’язок» — подтверждение вторым пунктом меню (не confirm()); запись помечается
// изменённой, Save общий, откат — журнал графа (Ctrl+Z / кнопка), грид таблицы перечитывает строки. 3) Пустая расстановка — та же авторасстановка, что «Типове розташування»
// (lanes при layout_mode 'lanes'), и при открытии — «вписать» (как кнопка p025). Выключатели: удаление — fe.ux.schemeGraphEdit, виджет — fe.ux.schemeGraphRowWidget,
// вписать при открытии — fe.ux.schemeGraphV2 (все — дефолт ВКЛ, без пересборки)
// виджет строки (widget-row) открыт и показывает строку таблицы графа (doc.nodes / doc.edges) — следящий режим: клик по узлу / связи переключает его. Закрыт (close / _softClosed —
// крестик, Esc) или показывает строку другой таблицы — нет
export function sg2RowCardFollow(WRow, cfg) {
    if (!isObj(WRow) || WRow.close || WRow._softClosed || !isObj(cfg)) return false
    const b = str(WRow.record && WRow.record._meta && WRow.record._meta.binding)
    return !!b && (b === str(cfg.nodes_binding) || b === str(cfg.edges_binding))
}
// строка по iroot карточки ('2' | '0.attrs.1' — как store.iroot) в массиве таблицы; нет — null
export function sg2RowAtIroot(rows, iroot, childPath = 'attrs') {
    const parts = str(iroot).split('.').filter((x) => x !== '')
    if (!parts.length) return null
    let list = Array.isArray(rows) ? rows : null, row = null
    for (let i = 0; i < parts.length; i++) {
        if (!list) return null
        const n = Number(parts[i])
        if (!Number.isInteger(n) || n < 0) return null
        row = list[n]
        if (!isObj(row)) return null
        if (i + 1 < parts.length) {
            if (parts[i + 1] !== childPath || i + 2 >= parts.length) return null
            const k = row[childPath]
            list = Array.isArray(k) ? k : null
            i++
        }
    }
    return row
}
// связи узла: строки doc.edges, где ключ узла — source или target (по edges_source_binding / edges_target_binding). → [{ row, index }] по убыванию индекса
// (удаление с конца не сдвигает остальные; откат вставляет в обратном порядке на те же места)
export function sg2NodeEdges(edgesRows, key, cfg) {
    const k = keyOf(key), out = []
    if (!k || !isObj(cfg)) return out
    ;(Array.isArray(edgesRows) ? edgesRows : []).forEach((row, index) => {
        if (!isObj(row)) return
        if (keyOf(getPath(row, cfg.edges_source_binding)) === k || keyOf(getPath(row, cfg.edges_target_binding)) === k) out.push({ row, index })
    })
    return out.sort((a, b) => b.index - a.index)
}
// план удаления узла (id модели): его строка doc.nodes (массив — верхний уровень или children_path группы, место) и связи. Ключ узла есть ещё у другой строки (дубль ключа) —
// связи остаются (их концы — тот, другой узел). → { row, arr, index, key, edges: [{ row, index }] } | null
export function sg2NodeDeletePlan(nodesRows, edgesRows, g, id, cfg) {
    if (!g || !g.nodes || !isObj(cfg) || !Array.isArray(nodesRows)) return null
    const leaf = (g.nodes.leaves || []).find((x) => sg2NodeId(x) === str(id))
    if (!leaf || leaf.path == null) return null
    const pid = str(leaf.path), at = sg2RowsByPath(nodesRows, cfg), row = at.get(pid)   // путь — как collectNodes (дети группы — без не-объектов)
    if (!isObj(row)) return null
    const cut = pid.lastIndexOf('.'), parent = cut > 0 ? at.get(pid.slice(0, cut)) : null
    const kids = parent && cfg.children_path ? getPath(parent, cfg.children_path) : undefined
    const arr = cut > 0 ? (Array.isArray(kids) ? kids : null) : nodesRows
    const index = arr ? arr.indexOf(row) : -1
    if (index < 0) return null
    const key = keyOf(leaf.key)
    const shared = !!key && ((g.nodes.leaves || []).filter((x) => x.key === key).length > 1 || !!(g.nodes.groupKeys && g.nodes.groupKeys.has(key)))
    return { row, arr, index, key, edges: shared ? [] : sg2NodeEdges(edgesRows, key, cfg) }
}
// подпись подтверждения удаления узла: без связей / одна / N (UI-строка — через t владельца)
export function sg2DeleteNodeYes(t_, n) {
    const tr = typeof t_ === 'function' ? t_ : (s) => s
    const c = Number(n) || 0
    return c <= 0 ? tr('Yes, delete the node') : c === 1 ? tr('Yes, delete the node and 1 link') : tr('Yes, delete the node and {n} links', { n: c })
}
// расстановка без узла (ключ удалённого узла не остаётся в layout_binding: новый узел с тем же ключом не встанет на его место); нет ключа / пусто — null (не писать)
export function sg2LayoutWithout(lay, id) {
    const n = normalizeLayout(lay), k = layoutKey(id)
    if (!n || !(k in n)) return null
    const out = { ...n }
    delete out[k]
    return out
}
// вписать при открытии: пустая расстановка (layout_binding пуст / {} — та же авторасстановка, что «Типове розташування») и тулбар (у кнопки «вписать» он же); выключатель — fe.ux.schemeGraphV2
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — остатки пробы): D2 — окно прокрутки графа по видимой области контейнера. sg2ScrollParent: ближайший предок с overflow-y auto / scroll / overlay, который сейчас
// прокручивается (scrollHeight > clientHeight), или корень документа (root), если прокручивается он; prev — найденный раньше и всё ещё предок — он же (липкий: после предела
// контейнер перестаёт прокручиваться, без липкости высота качалась бы). styleOf(el) → { overflowY }
export function sg2ScrollParent(el, styleOf, prev, root) {
    if (!el) return null
    if (prev && prev !== el && typeof prev.contains === 'function' && prev.contains(el)) return prev
    const scrolls = (p) => p.clientHeight > 0 && p.scrollHeight > p.clientHeight + 1
    for (let p = el.parentElement, i = 0; p && i < 60; p = p.parentElement, i++) {
        if (root && p === root) return scrolls(p) ? p : null
        let oy = ''
        try { oy = String((styleOf ? styleOf(p) : null)?.overflowY || '') } catch (e) { oy = '' }
        if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && scrolls(p)) return p
    }
    return null
}
// предел высоты окна прокрутки: видимая высота контейнера (viewH) − место над хостом в контейнере (above: вкладки, поля формы выше — хост целиком виден без прокрутки контейнера
// от начала) − отступ окна от верха хоста (top: поиск, строка подсказки) − нижний отступ хоста (padBottom: островок) − 4. Над хостом слишком много (меньше min) — без above: хост
// целиком помещается в контейнер, когда тот прокручен к нему. Не меньше min (160); viewH нет — 0 (без предела)
export function sg2ViewMaxH(o = {}) {
    const viewH = Number(o && o.viewH) || 0
    if (!(viewH > 0)) return 0
    const top = Math.max(0, Number(o.top) || 0), pad = Math.max(0, Number(o.padBottom) || 0), above = Math.max(0, Number(o.above) || 0), min = Number(o.min) > 0 ? Number(o.min) : 160
    const h1 = Math.floor(viewH - above - top - pad - 4)
    return h1 >= min ? h1 : Math.max(min, Math.floor(viewH - top - pad - 4))
}
export function sg2FitOnOpen(o = {}) { return !!(o && o.on && o.tb && !normalizeLayout(o.layout)) }
// таблицы шага журнала: пакет — все таблицы его шагов (по порядку), иначе — его таблица
export function sg2JournalTables(e) {
    if (!isObj(e)) return []
    if (e.op !== 'batch') return e.table ? [e.table] : []
    const out = []
    for (const s of Array.isArray(e.steps) ? e.steps : []) if (s && s.table && !out.includes(s.table)) out.push(s.table)
    return out
}

// ---------- IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): высота графа, подсказки ----------
// граф на всю доступную высоту виджета (как AttrGraph.attrResize): высота хоста = низ окна виджета − верх хоста − 2; островок кнопок — его низ справа. Выключатель §8 (дефолт ВКЛ;
// выкл — высота по содержимому и окно прокрутки по видимой области, D2)
export const SG2_FULLH_FLAG = 'fe.ux.schemeGraphFullHeight'
export function sg2FullHeightOn(setting) {
    try { return (typeof setting === 'function' ? setting(SG2_FULLH_FLAG, true) : true) !== false } catch (e) { return true }
}
// o: { widgetTop, widgetBottom (окно виджета #WIDGET<id>), hostTop, hostH (хост сейчас), min (attr.minHeight, 240), max (attr.maxHeight), size (attr.size, %), heightAdd,
// prev: { h — поставленная высота, wb — низ виджета при ней, grow — на сколько она подняла хост } }. → высота px или 0 (не менять: хост скрыт / виджет не измерен /
// верх хоста выше окна виджета — прокручено). Окно виджета выросло ровно на прошлый прирост хоста (высота виджета по содержимому — он тянется за хостом) — прошлое
// значение: без петли роста; обычное изменение окна (другой сдвиг низа) — пересчёт
export function sg2HostHeight(o = {}) {
    const wt = Number(o.widgetTop), wb = Number(o.widgetBottom), ht = Number(o.hostTop)
    if (![wt, wb, ht].every(Number.isFinite) || !(wb - wt > 0) || !(Number(o.hostH) > 0) || ht < wt) return 0
    let h = Math.floor(wb - ht) - 2
    const size = Number(o.size)
    if (size > 0 && size < 100) h = Math.round((h * size) / 100)
    const min = Number(o.min) > 0 ? Number(o.min) : 240
    if (h < min) h = min
    const max = Number(o.max)
    if (max > 0 && h > max) h = max
    const add = Number(o.heightAdd)
    if (Number.isFinite(add) && add) h += add
    const prev = o.prev
    if (prev && Number(prev.h) > 0 && Number(prev.grow) > 1 && Number.isFinite(Number(prev.wb)) && Math.abs(wb - Number(prev.wb) - Number(prev.grow)) <= 1) return prev.h
    return h
}
// подсказки над графом («Клик по связи…» и «Связей на узлы вне схемы: N») — вместе с легендой (кнопка pi-tags островка): тулбар выкл — всегда, как было
export const sg2HintsOn = (o = {}) => !o.tb || !!o.legendOn
